import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          "": "",
          "x of y": "%@ of %@",
          " %@Suite %@": " %1$@Suite %2$@",
          "#": "#",
          $: "$",
          "$20,000-$34,999": "$20,000-$34,999",
          "$35,000-$59,999": "$35,000-$59,999",
          "$60,000-$99,999": "$60,000-$99,999",
          "%.3f": "%.3f",
          "%@ Suite %@": "%1$@ Suite %2$@",
          "%@ and %@ %@": "%@ and %@ %@",
          "%@Page %i: %@ - missing %i signatures ":
            "%@Page %i: %@ - missing %i signatures ",
          "%@nd": "%@nd",
          "%@rd": "%@rd",
          "%@st": "%@st",
          "%@th": "%@th",
          "%i of %i": "%i of %i",
          ".": ".",
          0: "0",
          "0123456789.": "0123456789.,",
          1: "1",
          "1 of 2": "1 of 2",
          "10 Year Annual": "10 Year Annual",
          "10 Year Monthly": "10 Year Monthly",
          "10-14 years": "10-14 years",
          "15 years or more": "15 years or more",
          2: "2",
          "2 of 2": "2 of 2",
          "3+": "3+",
          "5 Year Annual": "5 Year Annual",
          "5 Year Monthly": "5 Year Monthly",
          "5-9 years": "5-9 years",
          "<$20,000": "<$20,000",
          ">$100,000": ">$100,000",
          ACES: "ACES",
          "ACES Income": "ACES Income",
          "AIR MILES details":
            "AIR MILES Reward Miles can be used towards the deposits of a CEFI plan at a rate of %i AIR MILES per $100.  AIR MILES can only be redeemed in multiples of %i.",
          Achievers: "Achievers",
          "Achievers Plan": "Achievers Plan",
          "Achievers Plan Disclosure": "Achievers Plan Disclosure",
          "Additional Subscriber Disclosure":
            "Additional Subscriber Disclosure",
          Advertising: "Advertising",
          Affordability_Limit:
            "Deposit amounts exceeds recommended affordability limits for your income level.",
          Agency: "Agency",
          Alberta: "Alberta",
          "All signatures will be lost, however documents can be re-created without signatures.   Tap CANCEL to continue signing these forms, or tap DISCARD to discard these forms and signatures.":
            "All signatures will be lost, however documents can be re-created without signatures.   Tap Cancel to continue signing these forms, or tap Discard to discard these forms and signatures.",
          "All signatures will be lost, however documents can be re-created without signatures.   Tap Cancel to continue signing these forms, or tap Discard to discard these forms and signatures.":
            "All signatures will be lost, however documents can be re-created without signatures.   Tap Cancel to continue signing these forms, or tap Discard to discard these forms and signatures.",
          Annual: "Annual",
          "Application for ACES": "Application for ACES",
          BCTESG: "BCTESG",
          "BCTESG Income": "BCTESG Income",
          "Beneficiary not eligible for group plan.":
            "Beneficiary not eligible for group plan.",
          Beni_bd_required: "Beneficiary birth date is a required field.",
          Beni_is_1: "%@ is 1 year old.",
          Beni_over_1: "%@ is %i years old.",
          Beni_under_1: "%@ is not yet 1 year old.",
          "British Columbia": "British Columbia",
          "By tapping Confirm below you will seal this enrolment, preventing any further changes and prepare it for upload to Head Office.":
            "By tapping Confirm below you will seal this enrolment, preventing any further changes and prepare it for upload to Head Office.",
          "CASL Form": "CASL Form",
          "CESG Appendix B": "CESG Appendix B",
          "CESG Appendix C": "CESG Appendix C",
          "CESG Appendix D": "CESG Appendix D",
          "CESG and CLB": "CESG and CLB",
          Cancel: "Cancel",
          "Cannot enrol unless at least one plan is setup":
            "Cannot enrol unless at least one plan is setup",
          Caution: "Caution",
          Confirm: "Confirm",
          "Confirm Expense!": "Confirm Expense!",
          Confirmation: "Confirmation",
          "Continue Signing": "Continue Signing",
          "Credit Card Disclosure Information":
            "Credit Card Disclosure Information",
          "DR Enrolment Checklist": "DR Enrolment Checklist",
          Daughter: "Daughter",
          "Debug Message":
            "There was an error loading the CEFI iPad App.  Tap Continue, if the problem persists tap Upload error to head office and contact Agent Services",
          "Debug Mode": "Debug Mode",
          "Deleting this enrolment is permenant and cannot be undone.  Do you wish to proceed?":
            "Deleting this enrolment is permenant and cannot be undone.  Do you wish to proceed?",
          Deposit: "Deposit",
          "Deposit code changed to match year of maturity.":
            "Deposit code changed to match year of maturity.",
          Discard: "Discard",
          "Discard Signatures & Edit": "Discard Signatures & Edit",
          "Disclosure of Grant Limits": "Disclosure of Grant Limits",
          "Disclosure of Sales Charges": "Disclosure of Sales Charges",
          "Disclosure of Third Party Financial Support":
            "Disclosure of Third Party Financial Support",
          "DocuSign #:": "DocuSign #:",
          Dollars: "Dollars",
          "Double tap to sign": "Double tap to sign",
          Dr: "Dr.",
          "Drivers License": "Drivers License",
          "Dual License Disclosure form": "Dual License Disclosure form",
          Duplicate: "Duplicate",
          E: "E",
          EAPs: "EAPs",
          "Education Savings": "Education Savings",
          "Email Warning": "Email Warning",
          English: "English",
          "Enrolment Application": "Enrolment Application",
          "Enrolment has a 'nil' uploadStatus: contact support.":
            "Enrolment has a 'nil' uploadStatus: contact support.",
          "Enrolment has already been successfully uploaded.":
            "Enrolment has already been successfully uploaded.",
          "Enrolment is already being uploaded":
            "Enrolment is already being uploaded",
          "Enrolment is at an unknown upload status please contact support":
            "Enrolment is at an unknown upload status please contact support",
          "Enrolment will begin uploading.  Please keep the CEFI app in the foreground until complete.":
            "Enrolment will begin uploading.  Please keep the CEFI app in the foreground until complete.",
          Error: "Error",
          "Escrow Agreement": "Escrow Agreement",
          Experienced: "Experienced",
          Export: "Export",
          F: "F",
          Female: "Female",
          French: "French",
          Granddaughter: "Granddaughter",
          Grandson: "Grandson",
          "Grant 2 page": "Grant 2 Page",
          "Grant 6 page": "Grant 6 page",
          "Grant Income": "Grant Income",
          Grant: "Grant",
          Group: "Group",
          "Group Option Plan": "Group Option Plan",
          "Group Option Plan Disclosure": "Group Option Plan Disclosure",
          "Group Plan": "Group Option Plan",
          "Group Plan Summary": "Group Plan Summary",
          "Has been uploaded to Head Office and cannot be unsealed.":
            "Has been uploaded to Head Office and cannot be unsealed.",
          "Head Office Referral": "Head Office Referral",
          High: "High",
          "If you want two group plans, the first must not be a T mode.":
            "If you want two group plans, the first must not be a T mode.",
          Inscript_1: "Because You\u2019re Special. Love, Mom & Dad",
          Inscript_10: "The small steps produce the big leaps.",
          Inscript_11: "Choose a star and reach for it.",
          Inscript_12: "The future belongs to you.",
          Inscript_13: "No dreamer too small; no dream too big!",
          Inscript_14: "Knowledge is Light, Enriching Life.",
          Inscript_15: "Knowledge is the key to the World",
          Inscript_16: "Knowledge is never lost \u2013 Love, Mom & Dad",
          Inscript_17: "Because you can be anything, Sweetheart.",
          Inscript_18: "Given with Love by Grandma & Grandpa",
          Inscript_19: "Spread your wings and soar. Love, Mom & Dad",
          Inscript_2: "We Believe in You \u2013 Mom & Dad",
          Inscript_20: "Knowledge gives you choices.",
          Inscript_21: "To Nurture your Dreams.",
          Inscript_22: "The best I can give beyond Love.",
          Inscript_23: "Achieving your dreams together.",
          Inscript_24: "We have guaranteed you a chance.",
          Inscript_25: "The first step towards your future.",
          Inscript_26: "\u201cif it\u2019s to be, it\u2019s up to me\u201d",
          Inscript_27: "Renewing the promise- Love, Mom & Dad",
          Inscript_28: "Always do your best \u2013 Love, Mom & Dad",
          Inscript_3: "Live, Love & Learn \u2013 Love, Mom & Dad",
          Inscript_4: "For your future \u2013 Love, Mom & Dad",
          Inscript_5: "Just because, Mom & Dad",
          Inscript_6: "With all our Love and money, Mom & Dad",
          Inscript_7: "We know you will \u2013 Love, Mom & Dad",
          Inscript_8: "Reach for the stars, Love Mom & Dad",
          Inscript_9: "Be the best you can be \u2013 the rest follows",
          J: "J",
          Joint: "Joint",
          KYC_Limit: "Deposit amount exceeds CEFI KYC affordability guideline!",
          "Know Your Client Objective is a required field":
            "Know Your Client Objective is a required field",
          "Know Your Client Risk Approximate Net Worth is a required field":
            "Know Your Client Risk Approximate Net Worth is a required field",
          "Know Your Client Risk Tolerance is a required field":
            "Know Your Client Risk Tolerance is a required field",
          "Know your Client": "Know your Client",
          "Know your Client Objectives are required fields":
            "Know your Client Objectives are required fields",
          "Less than 5": "Less than 5",
          Lifetime_Limit:
            "Deposit amounts exceeds RESP lifetime limit of $50,000 before insurance options.",
          Limited: "Limited",
          "Loading...": "Loading...",
          Low: "Low",
          M: "M",
          Male: "Male",
          "Mandatory before %@": "Mandatory before %@",
          "Mandatory immediately": "Mandatory immediately",
          Manitoba: "Manitoba",
          Maternity: "Maternity",
          "Maximum AIR MILES redemption for a Group plan is $%i per unit.  AIR MILES redemption amount has been adjusted.":
            "Maximum AIR MILES redemption for a Group plan is $%i per unit.  AIR MILES redemption amount has been adjusted.",
          "Maximum AIR MILES redemption for a Self-Initiated plan is $%i.  AIR MILES redemption amount has been adjusted.":
            "Maximum AIR MILES redemption for a Self-Initiated plan is $%i.  AIR MILES redemption amount has been adjusted.",
          "Maximum AIR MILES redemption for an Achievers plan is $%i per unit.  AIR MILES redemption amount has been adjusted.":
            "Maximum AIR MILES redemption for an Achievers plan is $%i per unit.  AIR MILES redemption amount has been adjusted.",
          "Maximum carry forward grant room for this beneficiary is $%i.  The carry forward amount has been adjusted.":
            "Maximum carry forward grant room for this beneficiary is $%i.  The carry forward amount has been adjusted.",
          Medium: "Medium",
          Miles: "Miles",
          Miss: "Miss",
          "Missing Fields": "Missing Fields",
          ModeName: "ModeName",
          Monthly: "Monthly",
          Mr: "Mr.",
          Mrs: "Mrs.",
          Ms: "Ms.",
          N: "N",
          NO: "NO",
          Nephew: "Nephew",
          "Net Savings": "Net Contributions",
          "New Brunswick": "New Brunswick",
          Newfoundland: "Newfoundland",
          Niece: "Niece",
          No: "No",
          None: "None",
          Normal: "Normal",
          "Northwest Territories": "Northwest Territories",
          "Not Applicable": "Not Applicable",
          "Not Signed": "Not Signed",
          "Not related": "Not related",
          "Not to seek employment": "Not to seek employment",
          "Nova Scotia": "Nova Scotia",
          Nunavut: "Nunavut",
          OK: "OK",
          "Office Visit": "Office Visit",
          "One-Time": "One-Time",
          Ontario: "Ontario",
          Other: "Other",
          "Other (Specify in Notes)": "Other (Specify in Notes)",
          "Other form": "Other form",
          "Overall Progress": "Overall Progress",
          "PO Box %@": "PO Box %@",
          Passport: "Passport",
          "Personal Meeting": "Personal Meeting",
          "Plan Illustration": "Plan Illustration",
          "Plan Warning": "Plan Warning",
          Plan_Mature:
            "The plan will mature on %@, in the year of %@'s %@ birthday.",
          "Please upload all signed enrolments before upgrading.":
            "Please upload all signed enrolments before upgrading.",
          "Prince Edward Island": "Prince Edward Island",
          Print: "Print",
          "Prospectus Date is a required field":
            "Prospectus Date is a required field",
          QESI: "QESI",
          "QESI Income": "QESI Income",
          Quarterly: "Quarterly",
          Quebec: "Quebec",
          "Referral Disclosure Information": "Referral Disclosure Information",
          "Relationship Disclosure Information":
            "Relationship Disclosure Information",
          "Restricted Client form": "Restricted Client form",
          "Return to previous employment": "Return to previous employment",
          "Return to previous employment but with reduced hours":
            "Return to previous employment but with reduced hours",
          S: "S",
          SAGES: "SAGES",
          "SAGES Income": "SAGES Income",
          "SAGES application resident since is a required field":
            "SAGES application resident since is a required field",
          Saskatchewan: "Saskatchewan",
          "Save Signatures & Exit": "Save Signatures & Exit",
          "Seek new employment": "Seek new employment",
          "Self-Initiated": "Self-Initiated",
          "Self-Initiated Option Plan": "Self-Initiated Option Plan",
          "Self-Initiated Option Plan Disclosure":
            "Self-Initiated Option Plan Disclosure",
          "Self-Initiated Plan": "Self-Initiated Option Plan",
          "Semi-Annually": "Semi-Annually",
          "Service Promise": "Service Promise",
          "Signed (Upload Required)": "Signed (Upload Required)",
          "Signed (Upload Required) [%i]": "Signed (Upload Required) [%i]",
          Single: "Single",
          Sir: "Sir",
          Son: "Son",
          "Store Size: %d megs": "Store Size: %d megs",
          "Subscriber 1": "Subscriber 1",
          "Subscriber 1 E-Mail address is a required field":
            "Subscriber 1 E-Mail address is a required field",
          "Subscriber 1 Investment Experience is a required field":
            "Subscriber 1 Investment Experience is a required field",
          "Subscriber 2": "Subscriber 2",
          "Subscriber 2 E-Mail address is a required field":
            "Subscriber 2 E-Mail address is a required field",
          "Subscriber 2 Investment Experience is a required field":
            "Subscriber 2 Investment Experience is a required field",
          "Supplemental Know your Client": "Supplemental Know your Client",
          "Telephone Call": "Telephone Call",
          "Temporary SIN Disclosure": "Temporary SIN Disclosure",
          "The beneficiary": "The beneficiary",
          "The enrolment cannot be unsealed because one of the additional beneficiary enrolments is currently sealed.  Unseal all additioal benenficairies before you can unseal the first beneificary.":
            "The enrolment cannot be unsealed because one of the additional beneficiary enrolments is currently sealed.  Unseal all additioal benenficairies before you can unseal the first beneificary.",
          "The enrolment is not sealed": "The enrolment is not sealed",
          "The first and additional plan must be of the same type.":
            "The first and second plan must be of the same type.",
          "Third Language Form": "Third Language Form",
          "This enrolment cannot be deleted because it is already sealed.":
            "This enrolment cannot be deleted because it is already sealed.",
          "This enrolment cannot be deleted because it is the first enrolment of a family enrolment.  You must delete the additional beneficiary enrolments first.":
            "This enrolment cannot be deleted because it is the first enrolment of a family enrolment.  You must delete the additional beneficiary enrolments first.",
          "This enrolment cannot be unsealed because it has been uploaded to head office already.  Please contact your branch manager if there are problems with this enrolment.":
            "This enrolment cannot be unsealed because it has been uploaded to head office already.  Please contact your branch manager if there are problems with this enrolment.",
          "This enrolment cannot be unsealed because the upload to head office was initiated.  Please complete the upload and contact your branch manager if there are problems with this enrolment.":
            "This enrolment cannot be unsealed because the upload to head office was initiated.  Please complete the upload and contact your branch manager if there are problems with this enrolment.",
          "This enrolment cannot be uploaded because has already been uploaded to head office.":
            "This enrolment cannot be uploaded because has already been uploaded to head office.",
          "This enrolment cannot be uploaded because it is not sealed.":
            "This enrolment cannot be uploaded because it is not sealed.",
          "This enrolment cannot be uploaded until all the enrolments in the family have been sealed.":
            "This enrolment cannot be uploaded until all the enrolments in the family have been sealed.",
          "This enrolment is in the process of being uploaded and cannot be unsealed.":
            "This enrolment is in the process of being uploaded and cannot be unsealed.",
          "This enrolment is not sealed.": "This enrolment is not sealed.",
          "This enrolment may not be signed and sealed at this time.  Required fields are missing from this enrolment":
            "This enrolment may not be signed and sealed at this time.  Required fields are missing from this enrolment",
          "This enrolment may not be signed and sealed at this time.  The 1st enrolment for the family must be signed before the additional enrolments":
            "This enrolment may not be signed and sealed at this time.  The 1st enrolment for the family must be signed before the additional enrolments",
          Transfer: "Transfer",
          Units: "Units",
          "Unknown Status": "Unknown Status",
          "Unknown signature status - contact support":
            "Unknown signature status - contact support",
          Unseal: "Unseal",
          "Unsealing this enrolment will discard all it's signatures but allow you to edit the contents of the enrolment.  Do you wish to proceed?":
            "Unsealing this enrolment will discard all it's signatures but allow you to edit the contents of the enrolment.  Do you wish to proceed?",
          Upload: "Upload",
          "Uploaded to Head Office": "Uploaded to Head Office",
          "Uploading %d of %d": "Uploading %d of %d",
          "Use iTunes File Sharing to retrieve the enrolment package for %@ %@.":
            "Use iTunes File Sharing to retrieve the enrolment package for %1$@ %2$@.",
          "Version: %@ %@": "Version: %@ %@",
          Warning: "Warning",
          "Warning for DocuSign:": "Warning for DocuSign:",
          "Warning!": "Warning!",
          "Would you like to copy the payment information from the first beneficiary? This will overwrite payment information entered for this beneficiary.":
            "Would you like to copy the payment information from the first beneficiary? This will overwrite payment information entered for this beneficiary.",
          Y: "Y",
          YES: "YES",
          Yes: "Yes",
          "You do not have email configured on your iPad.":
            "You do not have email configured on your iPad.",
          "You may Discard all signatures and edit this enrolment. You may Save signatures and add signing at a later time.  You may also Continue signing. ":
            "You may Discard all signatures and edit this enrolment. You may Save signatures and add signing at a later time.  You may also Continue signing. ",
          "Your DR code %@ is not licensed in the province %@.":
            "Your DR code %@ is not licensed in the province %@.",
          "Your contributions will earn you %i AIR MILES Reward Miles over the life of the plan!":
            "Your contributions will earn you %i AIR MILES Reward Miles over the life of the plan!",
          "Your contributions will earn you %i AIR MILES Reward Miles over the life of the plan!":
            "Your contributions will earn you %i AIR MILES Reward Miles over the life of the plan!",
          "Your contributions will earn you %i AIR MILES\u00ae Reward Miles over the life of the plan!":
            "Your contributions will earn you %i AIR MILES\u00ae Reward Miles over the life of the plan!",
          "Your plan has been set up for the beneficiary to commence post-secondary study in %i, during the year of the beneficiary's %ith birthday.":
            "Your plan has been set up for the beneficiary to commence post-secondary study in %i, during the year of the beneficiary's %ith birthday.",
          "Yukon Territories": "Yukon Territories",
          "application_to_KnowYourClient.afterMaternityLeaveEnds":
            "application_to_KnowYourClient.afterMaternityLeaveEnds",
          "application_to_KnowYourClient.approximateNetWorth":
            "application_to_KnowYourClient.approximateNetWorth",
          "application_to_KnowYourClient.objective":
            "application_to_KnowYourClient.objective",
          "application_to_KnowYourClient.riskTolerance":
            "application_to_KnowYourClient.riskTolerance",
          "application_to_KnowYourClient.drReason":
            "application_to_KnowYourClient.drReason",
          "application_to_KnowYourClient.vehicles":
            "application_to_KnowYourClient.vehicles",
          "application_to_Subscriber1.investmentExperience":
            "application_to_Subscriber1.investmentExperience",
          "application_to_Subscriber2.investmentExperience":
            "application_to_Subscriber2.investmentExperience",
          email: "email",
          switch_Deposit: "switch_Deposit",
          switch_Dollars: "switch_Dollars",
          switch_English: "switch_English",
          switch_Female: "switch_Female",
          switch_French: "switch_French",
          switch_Joint: "switch_Joint",
          switch_Male: "switch_Male",
          switch_Miles: "switch_Miles",
          switch_No: "switch_No",
          switch_Single: "switch_Single",
          switch_Units: "switch_Units",
          switch_Yes: "switch_Yes",
          "the beneficiary": "the beneficiary",
          answer: "answer",
          "select date": "select date",
          "select plan": "select plan",
        },
      },
      fr: {
        translation: {
          "x of y": "%@ de %@",
          "": "uytgjgyjy",
          " %@Suite %@": " %1$@App. %2$@",
          "#": "#",
          $: "$",
          $0: "$0",
          "$100,000": "$100,000",
          "$100.00": "$100.00",
          "$2,300": "$2,300",
          "$20,000-$34,999": "20 000 $ - 34 999 $",
          $2000: "$2000",
          $24000: "$24000",
          $3000: "$3000",
          "$35,000-$59,999": "35 000 $ - 59 999 $",
          $4000: "$4000",
          $500: "$500",
          "$500 Grant": "$500 Grant",
          "$60,000-$99,999": "60 000 $ - 99 999 $",
          "%.3f": "%.3f",
          "%@ Suite %@": "%1$@ App. %2$@",
          "%@ and %@ %@": "%@ et %@ %@",
          "%@Page %i: %@ - missing %i signatures ":
            "%@Page %i: %@ - %i signatures manquantes ",
          "%@nd": "%@e",
          "%@rd": "%@e",
          "%@st": "%@er",
          "%@th": "%@e",
          "%i of %i": "%i de %i",
          "+": "+",
          ".": ".",
          0: "0",
          "0123456789.": "0123456789.,",
          1: "1",
          "1 of 1": "1 of 1",
          "1 of 2": "1 de 2",
          "1.00": "1.00",
          "1.000": "1.000",
          "10 Year Annual": "Annuel sur 10 ans",
          "10 Year Monthly": "Mensuel sur 10 ans",
          '10"; *': '10"; *',
          "10-14 years": "10-14 ans",
          104700: "104700",
          12: "12",
          123123123: "123123123",
          "15 years or more": "15 ans et plus",
          15.988: "15.988",
          18: "18",
          "18 years": "18 years",
          "1st Dependant": "1er personne \u00e0 charge",
          2: "2",
          "2 of 2": "2 de 2",
          "2012-04-01": "2012-04-01",
          2030: "2030",
          "2nd Dependant": "2e personne \u00e0 charge",
          3: "3",
          "3221 North Service Road": "3221 North Service Road",
          "3221 North Service Road          Burlington, ON L7N 3G2":
            "3221 North Service Road          Burlington, ON L7N 3G2",
          "3221 North Service Road Burlington, ON L7N 3G2":
            "3221 North Service Road, Burlington, ON L7N 3G2",
          "3221 North Service Road, Burlington, ON L7N 3G2":
            "3221 chemin North Service, Burlington, Ontario, L7N 3G2",
          "3rd Dependant": "3e personne \u00e0 charge",
          4: "4",
          "4th Dependant": "4e personne \u00e0 charges",
          5: "5",
          "5 Year Annual": "Annuel sur 5 ans",
          "5 Year Monthly": "Mensuel sur 5 ans",
          "5-9 years": "5-9 ans",
          50000: "50000",
          "5th Dependant": "5e personne \u00e0 charge",
          6: "6",
          "6.00%": "6.00%",
          7: "7",
          8: "8",
          "800-246-1203": "800-246-1203",
          9: "9",
          "905-331-9977": "905-331-9977",
          "<$20,000": "< 20 000 $",
          ">$100,000": "> 100 000 $",
          "A-CESG Grant": "A-Subventions SCEE",
          "A-CESG Grant Income": "A-Revenu subventions SCEE",
          ACES: "ACES",
          "ACES Income": "Revenu ACES",
          "AIR MILES Collector Number": "Numero de AIR MILES",
          "AIR MILES Redemption": "AIR MILES\u00ae Remboursement",
          "AIR MILES Reward Miles can be used towards the deposits of a CEFI plan at a rate of 875 AIR MILES per $100.  AIR MILES can only be redeemed in multiples of 875.":
            "Milles de r\u00e9compense AIR MILES peuvent \u00eatre utilis\u00e9es pour les d\u00e9p\u00f4ts d'un plan CEFI \u00e0 un taux de 875 AIR MILES par tranche de 100 $. AIR MILES peuvent \u00eatre \u00e9chang\u00e9s uniquement en multiples de 875. ",
          "AIR MILES Reward Miles can be used towards the deposits of a CEFI plan at a rate of 875 AIR MILES per $100. AIR MILES can only be redeemed in multiples of 875.":
            "AIR MILES Reward Miles can be used towards the deposits of a CEFI plan at a rate of 950 AIR MILES per $100. AIR MILES can only be redeemed in multiples of 950.",
          "AIR MILES details":
            "Milles de r\u00e9compense AIR MILES peuvent \u00eatre utilis\u00e9es pour les d\u00e9p\u00f4ts de cette r\u00e9gime \u00e0 un taux de %i AIR MILES par 100$.  AIR MILES peuvent \u00eatre \u00e9chang\u00e9s uniquement en multiples de %i.",
          "AIR MILES\u00ae Redemption": "AIR MILES\u00ae Remboursement",
          "APS View Controller": "APS View Controller",
          "Account Holder": "Titulaire du compte:",
          "Account Number": "Num\u00e9ro de compte",
          Achievers: "Performants",
          "Achievers Plan": "R\u00e9gime des performants",
          "Achievers Plan Disclosure":
            "Divulgation - R\u00e9gime des performants",
          Actions: "Actions",
          "Additional Criteria - $100 Grants":
            "Additional Criteria - $100 Grants",
          "Additional Subscriber Disclosure":
            "Divulgation additionnelle de souscripteur",
          Address: "Adresse",
          Advertising: "Publicit\u00e9",
          Affordability_Limit:
            "Montants des d\u00e9p\u00f4ts d\u00e9passe les limites d'accessibilit\u00e9 recommand\u00e9es pour votre niveau de revenu.",
          "After leave end parent(s) will:":
            "Apre\u0300s le conge\u0301 parental, les parents seront:",
          "After leave ends": "After leave ends",
          "Age of Beneficiary in Maturity Year":
            "\u00c2ge du b\u00e9n\u00e9ficiaire dans l'ann\u00e9e d'\u00e9ch\u00e9ance",
          "Age of the youngest potential beneficairy":
            "Plus jeune b\u00e9n\u00e9ficiaire potentiel",
          Agency: "Organisme",
          "Agent Name": "Agent Name",
          "Agent Status": "Agent Status",
          "Agent Zero": "Agent Zero",
          "Agreement Number": "Num\u00e9ro de la convention ",
          "Agreement in Place?": "Accord en place ?",
          Alberta: "Alberta",
          "Alberta Grant": "Alberta Grant",
          "All signatures will be lost, however documents can be re-created without signatures.   Tap CANCEL to continue signing these forms, or tap DISCARD to discard these forms and signatures.":
            "Toutes les signatures seront perdues, mais les documents peuvent \u00eatre recr\u00e9\u00e9es sans signatures.  \u00a0 Appuyez sur Annuler pour continuer de signer ces formulaires, ou appuyez sur Rejeter pour effacer ces formes et les signatures.",
          "All signatures will be lost, however documents can be re-created without signatures.   Tap Cancel to continue signing these forms, or tap Discard to discard these forms and signatures.":
            "Toutes les signatures seront perdues, mais les documents peuvent \u00eatre recr\u00e9\u00e9es sans signatures.  \u00a0 Appuyez sur Annuler pour continuer de signer ces formulaires, ou appuyez sur Rejeter pour effacer ces formes et les signatures.",
          Amount: "Montant",
          "Amount Required on Next Contribution":
            "Montant requis sur le d\u00e9p\u00f4t prochain",
          "An Illustration of Your Self-Initiated Option Plan":
            "Une illustration des prestations",
          "An Illustration of your Group Option Plan":
            "Une illustration des prestations",
          Annual: "Annuel",
          "Annual Disposable Income": "Revenu annuel disponible",
          "Annual Income": "Revenu annuel",
          "Another Gender": "Un autre genre",
          "Application Started Time Stamp": "Application Started Time Stamp",
          "Application for ACES": "Formulaire d'ACES",
          Applications: "Applications",
          "Apply for $500 Initial Grant": "Apply for $500 Initial Grant",
          "Apply for 11 Year Grant": "Apply for 11 Year Grant",
          "Apply for 14 Year Grant": "Apply for 14 Year Grant",
          "Apply for 8 Year Grant": "Apply for 8 Year Grant",
          "Approximate Net Worth": "Valeur nette approximative",
          Appt: "Appt",
          "Are you borrowing to invest in this plan(s)?":
            "Empruntez-vous pour investir dans ces r\u00e9gimes ?",
          B: "D",
          BCTESG: "SEEEFCB",
          "BCTESG Grant": "SEEEFCB",
          "BM/PTO Approved": "BM / PTO Approuv\u00e9",
          Bank: "Banque",
          "Bank Deposits, ST": "Stocks, MF",
          "Bank Information": "Informations bancaires",
          Basic: "\u00c9l\u00e9mentaire",
          "Before: September 24, 2012": "Before: September 24, 2012",
          "Bene First Name": "Bene First Name",
          "Bene Last Name": "Bene Last Name",
          Beneficiary: "B\u00e9n\u00e9ficiaire",
          "Beneficiary Age": "Age du b\u00e9n\u00e9ficiaire",
          "Beneficiary Age  at Maturity":
            "\u00c2ge du b\u00e9n\u00e9ficiaire \u00e0 l'\u00e9ch\u00e9ance",
          "Beneficiary Birth Date":
            "Date de naissance du b\u00e9n\u00e9ficiaire",
          "Beneficiary Birthdate is set in the Basic Information Section":
            "La date de naissance du b\u00e9n\u00e9ficiaire est indiqu\u00e9e dans la Section Information de base",
          "Beneficiary Information":
            "Renseignements sur le b\u00e9n\u00e9ficiaire",
          "Beneficiary Insurance": "Assurance de b\u00e9n\u00e9ficiaire",
          Insurance: "Assurance",
          Logout: "Déconnecter",
          "Beneficiary Name": "Nom du b\u00e9n\u00e9ficiaire",
          "Beneficiary Resident of SK since": "R\u00e9sident de la SASK depuis",
          "Beneficiary birth date is a required field.":
            "La date de naissance du b\u00e9n\u00e9ficiaire est n\u00e9cessaire",
          "Beneficiary birthdate":
            "Date de naissance du b\u00e9n\u00e9ficiaire",
          "Beneficiary is a dependant":
            "B\u00e9n\u00e9ficiaire est un d\u00e9pendant",
          "Beneficiary not eligible for group plan.":
            "B\u00e9n\u00e9ficiaire inadmissible au r\u00e9gime collectif",
          "Beneficiary \u2028Birthdate":
            "Date de naissance du b\u00e9n\u00e9ficiaire",
          "Beneficiary \u2028Name": "Nom du b\u00e9n\u00e9ficiaire",
          "Beneficiary's First name": "Beneficiary's First name",
          "Beneficiary's Last Name": "Beneficiary's Last Name",
          Beni_bd_required:
            "La date de naissance du b\u00e9n\u00e9ficiaire est n\u00e9cessaire",
          Beni_is_1: "%@ a 1 an.",
          Beni_over_1: "%@ a %i ans.",
          Beni_under_1: "%@ n'a pas encore 1 an",
          "Birth Date": "Date de naissance",
          "Birthdate Popup": "Birthdate Popup",
          "Breakdown of your Achievers Plan (Estimate)": "Valeur des avantages",
          "Breakdown of your Group Option Plan (Estimate)":
            "Valeur des avantages",
          "Breakdown of your Self-Initiated Plan (Estimate)":
            "Valeur des avantages",
          "British Columbia": "Colombie-Britannique",
          Burlington: "Burlington",
          "Business Phone": "T\u00e9l\u00e9phone au bureau",
          "Business Telephone": "T\u00e9l\u00e9phone au travail",
          "By tapping Confirm below you will seal this enrolment, preventing any further changes and prepare it for upload to Head Office.":
            "Confirmer en appuyant sur ci-dessous vous sceller cette inscription, emp\u00eachant toute modification ult\u00e9rieure et le pr\u00e9parer pour t\u00e9l\u00e9charger au si\u00e8ge social.",
          "CASL View Controller": "CASL View Controller",
          CCB: "ACE",
          CEFI: "F\u00c9EI",
          "CEFI Platinum Plus\u00ae MasterCard": "MasterCard Platine Plus FEEI",
          CESG: "SCEE",
          "CESG Appendix B": "SCEE Annexe B",
          "CESG Grant": "Subventions SCEE",
          "CESG Grant Income": "Revenu subventions SCEE",
          "CESG and CLB": "SCEE et BEC",
          CLB: "BEC",
          "CLB Grant": "Subventions BEC",
          "CLB Grant Income": "Revenu de subvention BEC",
          "CLB Only": "BEC seulement",
          "CP First Name": "CP First Name",
          "CP Last Name": "CP Last Name",
          "CVV/CVC": "Num\u00e9ro CVV",
          "Can you keep contributions until maturity?":
            "Pouvez-vous conserver les cotisations jusqu'a l'echeance ?",
          "Canada Education Savings Grants":
            "Subvention canadienne pour l'\u00e9pargne-\u00e9tudes",
          "Canada Learning Bond": "Bon d'\u00e9tudes canadien",
          Cancel: "Annuler",
          "Cannot enrol unless at least one plan is setup":
            "Ne peut s'inscrire que si au moins un r\u00e9gime est ouvert",
          "Card Verification Value": "Card Verification Value",
          "Carry Forward Grant Room": "Report de droits aux subventions",
          Caution: "Prudence",
          "Certificate Inscription": "Certificat d'inscription",
          "Certificate Inscription_B": "Certificat inscription",
          Certificateinscription: "Certificateinscription",
          Charge: "Frais d'inscription",
          "Check expense!": "Check expense!",
          "Cheques Payable to:                            Children's Education Trust":
            "Ch\u00e8ques \u00e0 l'ordre de:                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Fiducie pour l\u2019\u00c9ducation des Enfants",
          "Cheques Payable to: Children's Education Trust":
            "Ch\u00e8ques \u00e0 l'ordre de: Fiducie pour l\u2019\u00c9ducation des Enfants",
          "Child Care": "Garde d'enfants",
          "Children's Education Funds Inc.":
            "Fonds d\u2019\u00e9tudes pour les enfants Inc.",
          "Ch\u00e8ques \u00e0 l'ordre de:                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Fiducie pour l\u2019\u00c9ducation des Enfants":
            "Ch\u00e8ques \u00e0 l'ordre de:                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            Fiducie pour l\u2019\u00c9ducation des Enfants",
          "Ch\u00e8ques \u00e0 l'ordre de: Fiducie pour l\u2019\u00c9ducation des Enfants":
            "Ch\u00e8ques \u00e0 l'ordre de: Fiducie pour l\u2019\u00c9ducation des Enfants",
          City: "Ville",
          "City & Province": "Ville et Province",
          "City/Town/Municipality": "City/Town/Municipality",
          "City/Town/Munipality and Province of School":
            "City/Town/Munipality and Province of School",
          "Close Configuration": "Close Configuration",
          Clothing: "V\u00eatements",
          "Clothing ": "V\u00eatements",
          Code: "Code",
          Commitment: "Engagement",
          "Politically Exposed Person (PEP)":
            "Personne politiquement exposée (PPE)",
          "Are you a politically exposed person (PEP)? A politically exposed person is defined as an individual who holds a prominent public position or function in a government, international organization, or any other public entity, including their immediate family members and close associates.":
            "Êtes-vous une personne politiquement exposée (PPE)? Une personne politiquement exposée est définie comme un individu qui occupe une fonction publique importante au sein d’un gouvernement, d’une organisation internationale ou de tout autre organisme public, y compris les membres de sa famille immédiate et ses proches associés.",
          "I believe the plan investment is suitable for the client because The subscriber(s) wish to save for post-secondary education and :":
            "Je crois que l’investissement dans le régime convient au(x) souscripteur(s) parce que :",
          "the proposed contributions are within CEFI’s affordability guidelines":
            "Le ou les souscripteurs souhaitent épargner en vue des études postsecondaires et les cotisations proposées respectent les lignes directrices de FEEI en matière d’abordabilité.",
          "the proposed plan is onside risk tolerance":
            "Le ou les souscripteurs souhaitent épargner en vue des études postsecondaires et le régime proposé respecte la tolérance au risque.",
          "Other (Please note in the KYC Notes Section)":
            "Autre – Veuillez l'indiquer dans la section Notes CVC",
          "The subscriber(s) wish to save for post-secondary education and the proposed contributions are within CEFI’s affordability guidelines":
            "Le ou les souscripteurs souhaitent épargner en vue des études postsecondaires et les cotisations proposées respectent les lignes directrices de FEEI en matière d’abordabilité.",
          "The subscriber(s) wish to save for post-secondary education and the proposed plan is onside risk tolerance":
            "Le ou les souscripteurs souhaitent épargner en vue des études postsecondaires et le régime proposé respecte la tolérance au risque.",
          "Other (Please note in the KYC Notes Section)":
            "Autre – Veuillez l'indiquer dans la section Notes CVC",
          "select reason": "Sélectionnez la raison",
          "Completion Insurance": "Assurance de bonne fin",
          "Compliance Approved": "Conformit\u00e9 approuv\u00e9",
          Confirm: "Confirmer",
          "Confirm Expense!": "Confirmer d\u00e9penses!",
          Confirmation: "Confirmation",
          "Continue Signing": "Continuer Signature",
          "Continue to CEFI iPad App": "Continuer \u00e0 l'App iPad FEEI",
          "Contribution Amount": "Montant de cotisation",
          Contributions: "Cotisations",
          Copy: "Copie",
          "Copy Account Information from First Beneficiary":
            "Copier les informations de premier b\u00e9n\u00e9ficiaire",
          Country: "Pays",
          "Create 1 Test Agent Per Province":
            "Create 1 Test Agent Per Province",
          "Credit Card": "Carte de cr\u00e9dit",
          "CREDIT CARD": "CARTE DE CRÉDIT",

          "Credit Card Number": "Carte de cr\u00e9dit",
          "Credit Card Type": "Type de carte",
          CreditSubscriber: "CreditSubscriber",
          "Critical Illness Insurance": "Assurance de maladie critique",
          "Custodial Parent": "Parent ayant la garde ou Tuteur l\u00e9gal",
          "Custodial Parent BC resident ID type":
            "Genre d\u2019identification du Parent ayant la garde r\u00e9sident de la C-B",
          "Custodial Parent_B": "Parent ayant la garde",
          DD: "JJ",
          "DR Code": "Agent Code",
          "DR Enrolment Checklist":
            "Liste de v\u00e9rification d'adh\u00e9sion pour le repr\u00e9sentant de courtier",
          "DR Relationship Picker": "DR Relationship Picker",
          Date: "Date",
          "Date Financial Support will end":
            "Date o\u00f9 l\u2019aide financi\u00e8re prendra fin",
          "Date by which parent(s) will have returned to work":
            "Date ou\u0300 le(s) parent(s) retournera(ont) au travail",
          "Date of Birth": "Date de naissance",
          "Date of Presentation": "Date de la pr\u00e9sentation",
          "Date/Time": "Date/Heure",
          Daughter: "Fille",
          "Dealing Representative": "Repr\u00e9sentant de courtier",
          "Dealing Representative Code": "Dealing Representative Code",
          "Dealing Representative Name": "Nom du repr\u00e9sentant de courtier",
          "Debug Message":
            "Il ya eu une erreur lors du chargement de l'App iPad FEEI. Appuyez sur Continuer, si le probl\u00e8me persiste robinet T\u00e9l\u00e9chargez erreur au si\u00e8ge social et communiquer avec les Services Agent",
          "Debug Mode": "Debug Mode",
          "Default Dealing Representative": "Default Dealing Representative",
          Delete: "Effacer",
          "Deleting this enrolment is permenant and cannot be undone.  Do you wish to proceed?":
            "Supprimer cette inscription sera permanente et irr\u00e9versible. Souhaitez-vous continuer ?",
          "Dependant 1 Name": "Nom",
          "Dependant 2 Name": "Nom",
          "Dependant 3 Name": "Nom",
          "Dependant 4 Name": "Nom",
          "Dependant 5 Name": "Dependant 5 Name",
          Dependants: "Personnes \u00e0 charge",
          Deposit: "D\u00e9p\u00f4t",
          "Deposit Amount": "Montant de d\u00e9p\u00f4t",
          "Deposit Code": "Code de d\u00e9p\u00f4t",
          "Deposit Mode": "Mode de d\u00e9p\u020ft",
          "Deposit code changed to match year of maturity.":
            "Code de d\u00e9p\u00f4t modifi\u00e9s pour correspondre \u00e0 l'ann\u00e9e de la maturit\u00e9.",
          "Depository Fees": "Frais",
          "Depository Fees\u00b3": "Frais\u00b2",
          "Depository Fees\u00b9": "Frais\u00b9",
          "Depository Fees\u2074": "Frais\u00b3",
          Deposits: "D\u00e9p\u00f4ts",
          Detail: "Detail",
          Discard: "Jeter",
          "Discard Signatures & Edit": "Jeter Signatures & Modifier",
          "Disclosure of Sales Charges": "Disclosure of Sales Charges",
          "Disclosure of Third Party Financial Support":
            "Divulgation d\u2019appui financier par une tierce partie",
          "Disposable Income Exceeded": "Revenu disponible dépassé",
          "Does any subscriber on this application meet the ACES Requirements?":
            "Does any subscriber on this application meet the ACES Requirements?",
          "Does each subscriber read, speak and understand English or French?":
            "Est-ce que chaque souscripteur lit, parle et comprend l'anglais ou le fran\u00e7ais ?",
          Dollars: "Dollars",
          "Double tap to sign": "Appuyez deux fois sur pour signer",
          Dr: "Dr.",
          "Drivers License": "Permis de conduire",
          "BC Drivers License": "Permis de conduire de la Colombie-Britannique",
          "BC Identification Card":
            "Carte d'identit\u00e9 de la Colombie-Britannique",
          "BC Services Card": "Carte de services de la Colombie-Britannique",
          "Drivers license or Passport": "Passeport ou permis de conduire",
          "Dual License Disclosure form": "Dual License Disclosure formulaire",
          Duplicate: "Dupliquer",
          "E-Mail Address": "Adresse e-mail",
          "E-mail Address": "Adresse courriel",
          EAP: "PAE",
          EAPs: "PAE",
          ENVIRONMENT: "ENVIRONMENT",
          "Edit Enrolment": "Annuler",
          "Education Savings": "\u00c9pargne \u00e9tudes",
          "Effective Date": "Date d'effet",
          "Either parent on maternity/parental leave?":
            "Un parent en conge\u0301 de maternite\u0301 ?",
          "Electronic Consent": "Consentement",
          "Email Warning": "Attention e-mail",
          Employer: "Employeur",
          "Employer Address": "Adresse de l'employeur",
          "Employer Industry": "Domaine d\u2019emploi",
          "Enables editing & requires new signatures":
            "Permet l'\u00e9dition et n\u00e9cessite de nouvelles signatures",
          English: "Anglais",
          "Enrichment Fund Payments":
            "Paiements du Fond complémentaire de bourses d’études",
          "Enrol Additional Beneficiary":
            "B\u00e9n\u00e9ficiaire suppl\u00e9mentaire",
          Enrolment: "Inscription",
          "Enrolment Application": "Formulaire de demande",
          "Enrolment Special Instructions":
            "Instructions sp\u00e9ciales d'inscription",
          "Enrolment Status": "Application Detail",
          "Enrolment has a 'nil' uploadStatus: contact support.":
            "Enrolment has a 'nil' uploadStatus: contact support.",
          "Enrolment has already been successfully uploaded.":
            "es inscriptions ont d\u00e9j\u00e0 \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9 avec succ\u00e8s.",
          "Enrolment is already being uploaded":
            "L'inscription est d'ores et d\u00e9j\u00e0 t\u00e9l\u00e9charg\u00e9es",
          "Enrolment is at an unknown upload status please contact support":
            "Enrolment is at an unknown upload status please contact support",
          "Enrolment will begin uploading.  Please keep the CEFI app in the foreground until complete.":
            "Inscription d\u00e9butera le t\u00e9l\u00e9chargement. S'il vous pla\u00eet garder le CEFI application au premier plan jusqu'\u00e0 son terme.",
          Environment: "Environment",
          Error: "Erreur",
          "Escrow Agreement": "Convention d'entiercement",
          "Estimate Monthly Expenses":
            "Estimation des d\u00e9penses mensuelles",
          "Estimate Monthly Expenses After Maternity/Parental Leave":
            "Estimation des d\u00e9penses mensuelles apre\u0300s le conge\u0301 parental",
          "Estimate Monthly Income": "Estimation de revenu mensuel",
          "Estimate Monthly Income After Maternity/Parental Leave":
            "Estimation de revenu mensuel apre\u0300s le conge\u0301 parental",
          "Estimated Disposable Income": "Estimation du revenu disponible",
          "Estimated Monthly Disposable Income After Maternity/Parental Leave":
            "Estimation de revenu disponible mensuel apre\u0300s le conge\u0301 parental",
          "Estimated Monthly Income": "Estimation du revenu mensuel",
          "Estimated Starting Studies in Year":
            "Estimation des \u00e9tudes compter de l'ann\u00e9e",
          "Estimated Total Expenses": "Estimation des d\u00e9penses totales",
          "Estimated Total Expenses ": "Estimation des d\u00e9penses totales",
          "Existing CET Subscriber":
            "\u00cates-vous d\u00e9j\u00e0 un souscripteur de la FEE",
          Experienced: "Consid\u00e9rable",
          Expiry: "Expiration",
          Export: "Exporter",
          "Export error to iTunes": "Export d'erreur sur iTunes",
          F: "F",
          development: "développement",
          "Newfoundland and Labrador": "Terre-Neuve et Labrador",
          "Family Enrolments": "Inscriptions famille",
          "Family Enrolment": "Inscription famille",

          "Family Income": "Revenu familial",
          "Family Information": "Renseignements sur la famille",
          "Family Yearly Gross Income": "Du revenu familial annuel brut",
          "Family Yearly Gross Income (Excluding Temp)":
            "Du revenu familial annuel brut",
          "Family with 3 beneficiaries":
            "Famille avec 3 b\u00e9n\u00e9ficiaires",
          "Federal Grants": "Subventions f\u00e9d\u00e9rales",
          "Fees\u00b9": "Frais\u00b2",
          Female: "F\u00e9minin",
          "Fetch Upload Status": "Fetch Upload Status",
          "Financial Support Details":
            "D\u00e9tails de l\u2019aide financi\u00e8re",
          "First & Last Name": "Pr\u00e9nom et nom",
          "First Name": "Pr\u00e9nom",
          "First Plan": "Premier r\u00e9gime",
          "First Plan Payment": "Paiements du 1er r\u00e9gime",
          "Fonds d'\u00c9tudes pour les Enfants Inc.":
            "Fonds d'\u00c9tudes pour les Enfants Inc.",
          "For 28 years in a row, the CET Group Option Plan has proudly paid the highest 1st Scholarships compared to other nationally available group scholarship plans.":
            "Pendant 28 ann\u00e9es cons\u00e9cutives, le r\u00e9gime collectif de la FEE a fi\u00e8rement vers\u00e9 les 1\u00e8res bourses d\u2019\u00e9tudes les plus \u00e9lev\u00e9es comparativement \u00e0 d\u2019autres r\u00e9gimes collectifs de bourses d\u2019\u00e9tudes.",
          "For illustration purposes only": "Aux fins d'illustration seulement",
          Form: "Form",
          "Form Incomplete": "Form Incomplete",
          "Formulaire incomplet ": "Formulaire incomplet ",
          French: "Fran\u00e7ais",
          Frequency: "Fr\u00e9quence de d\u00e9p\u00f4t",
          "From RESP Contract Number": "Num\u00e9ro de contrat de REEE",
          "GPS View Controller": "GPS View Controller",
          Gender: "Sexe",
          "Generate Quotation": "G\u00e9n\u00e9rer des devis",
          "Given Name": "Pr\u00e9nom",
          "Government Grants": "Subventions gouvernementales",
          Granddaughter: "Petite fille",
          Grandson: "Petit fils",
          "Grant 2 page": "Souvention 2 page",
          "Grant 6 page": "Souvention 6 page",
          "Grant Income": "Revenu subvention",
          Grant: "Subvention",
          "Greg McMullin and Mandy Wong": "Greg McMullin and Mandy Wong",
          Groceries: "Epicerie",
          "Groceries ": "Epicerie",
          Gross: "Brut",
          Group: "Collectif",
          "Group Option Plan": "R\u00e9gime collectif",
          "Group Option Plan Disclosure": "Divulgation - R\u00e9gime collectif",
          "Group Plan": "R\u00e9gime collectif",
          Guardian: "Parent ayant la garde",
          "Hard Delete": "Hard Delete",
          "Has at least $100 been contributed into the Beneficiary's RESP within the past 12 months?":
            "Has at least $100 been contributed into the Beneficiary's RESP within the past 12 months?",
          "Has been uploaded to Head Office and cannot be unsealed.":
            "A \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9e vers le si\u00e8ge social et ne peut pas \u00eatre descell\u00e9e",
          "Head Office Referral": "R\u00e9f\u00e9rence du si\u00e8ge",
          "Head Office Status": "Statut Si\u00e8ge",
          "Head Office status": "Statut Si\u00e8ge",
          High: "Haut",
          "Home Address": "Adresse du domicile",
          "Home Phone": "T\u00e9l\u00e9phone \u00e0 la maison",
          "Home Telephone": "T\u00e9l\u00e9phone \u00e0 la maison",
          "How did you meet the DR?":
            "Comment le souscripteur a-t-il rencontr\u00e9 son RC ?",
          "ID Expiry (mm/yy)": "Expiration (mm/aa)",
          "ID Number": "# d\u2019identification",
          Identification: "Identification",
          Comments: "Commentaires",
          "Identification Number": "Identification",
          "If a pre-authorized debit is returned to the Depository by the bank for reason of non-sufficient funds the bank may, a the suggestion of the Depository, draw on the bank account indicated above within thirty days of such return, any amount outstanding.":
            "Fonds d\u2019\u00e9tudes pour les enfants Inc.",
          "If no, has the sales representative fully explained the details of the plan to you? (if no, please elaborate under special instructions)":
            "Si vous avez r\u00e9pondu non, est-ce que le-la repr\u00e9sentant-e vous a expliqu\u00e9 compl\u00e8tement les d\u00e9tails du r\u00e9gime ?",
          "If no, has the sales representative fully explained the details of the plan to you? (if no, please elaborate under special instructions) ":
            "Si vous avez r\u00e9pondu non, est-ce que le-la repr\u00e9sentant-e vous a expliqu\u00e9 compl\u00e8tement les d\u00e9tails du r\u00e9gime ?",
          "If you want two group plans, the first must not be a T mode.":
            "Si vous voulez deux plans de groupe, le premier ne doit pas \u00eatre un mode T.",
          "Initial Contribution": "Cotisation initial",
          "Initial Contribution Amount": "Montant de cotisation initiale",
          "Initial Deposit Date": "Date du d\u00e9p\u00f4t initial",
          "Initial Deposit Method": "Mode du d\u00e9p\u00f4t initial",
          InitialDepositMethod: "InitialDepositMethod",
          Inscript_1: "Bonne chance dans tes \u00e9tudes. Papa et Maman",
          Inscript_10: "L'avenir t'appartient. Nous te l'offrons!",
          Inscript_11: "Pour r\u00e9aliser tes ambitions. Maman",
          Inscript_12: "Pour un meilleur avenir, Papa et Maman",
          Inscript_13: "Pour r\u00e9aliser tes r\u00eaves, de Papa et Maman ",
          Inscript_14: "Crois en toi et le future t'appartiendra",
          Inscript_15: "Nous croyons en toi et le futur t'appartiendra",
          Inscript_16: "Poursuis tes r\u00eaves de Maman et Papa",
          Inscript_17: "Beaucoup de succ\u00e8s, avec amour Maman",
          Inscript_18: "Pour ton avenir avec amour, Grand-papa et Grand-maman",
          Inscript_19: "Le succ\u00e8s depend de toi-m\u00eame",
          Inscript_2: "Bonne chance pour ton avenir",
          Inscript_20: "Crois dan tes r\u00eaves. Papa et Maman",
          Inscript_21: "Poursuis tes r\u00eaves de Maman et Papa",
          Inscript_22: "Bon succ\u00e8s dans tes \u00e9tudes",
          Inscript_23: "L'\u00e9ducation; la clef de ton ind\u00e9pendance",
          Inscript_24: "Quand on veut bien, on peut aller loin",
          Inscript_25: "L'\u00e9ducation est le plus be h\u00e9ritage",
          Inscript_26: "L'education, c'est las plus grande richesse",
          Inscript_27:
            "Pers\u00e9v\u00e8re et tu r\u00e9ussiras. Maman et Papa",
          Inscript_28: "La connaissance te donne des choix",
          Inscript_3: "Le succ\u00e8s depend de toi. Papa et Maman",
          Inscript_4: "Pour ensoleiller ton avenir",
          Inscript_5: "La vie t'appartient. Avec amour, Papa et Maman",
          Inscript_6: "L'\u00e9ducation ouvre les portes du futur",
          Inscript_7: "A notre ch\u00e9rie pour ton futur. Papa et Maman",
          Inscript_8: "L'\u00e9ducation est la clef du succ\u00e8s",
          Inscript_9: "Pour r\u00e9aliser tes r\u00eaves et tes objectifs",
          "Insurance (Life, Property)": "Assurances (Vie, Biens)",
          "Insurance Options": "Options d'assurance",
          "Insurance Premiums": "Primes d'assurance",
          "Insurance Premiums\u00b2": "Primes d'assurance\u00b3",
          "Insurance Premiums\u2074": "Montant discr\u00e9tionnaire\u00b9",
          "Insurance Premiums\u2075": "Primes d'assurance\u2074",
          "Insurance options must be configured on the first plan":
            "Insurance options must be configured on the first plan",
          "Investment Code/Name": "Code ou nom du placement",
          "Investment Exp": "Exp\u00e9rience en placements",
          "Investment Experience": "Exp\u00e9rience en placements",
          "Investment Types": "Types de placements",
          "Is the Default DR": "Is the Default Agent",
          "Is this client refererred to CEFI under a referral agreement?":
            "Est-ce que ce client a \u00e9t\u00e9 r\u00e9f\u00e9r\u00e9 \u00e0 F\u00c9E par une entente pour diriger des clients ?",
          "Is this client refererred to Children's Education Funds Inc. under a referral agreement?":
            "Est-ce que ce client a \u00e9t\u00e9 r\u00e9f\u00e9r\u00e9 \u00e0 F\u00c9E par une entente pour diriger des clients ?",
          "Is this the correct age of the youngest potential beneficiary?":
            "Est-ce le bon jeune beneficairy potentiel ?",
          "Is this a Greatway referral?":
            "S'agit-il d'une recommandation de Greatway ?",
          J: "C",
          Joint: "Conjoint",
          "Joint Subscriber": "Cosouscripteur",
          KYC_Limit:
            "Le montant du d\u00e9p\u00f4t d\u00e9passe les lignes directrices d\u2019accessibilit\u00e9 CVC du FEEI!",
          "Know Your Client Form Type": "Type de formulaire CVC",
          "Know Your Client Notes:": "Notes de connaissez votre client:",
          "Know Your Client Objective is a required field":
            "Objectif est une zone de saisie obligatoire",
          "Know Your Client Risk Approximate Net Worth is a required field":
            "Avoir net approximatif est une zone de saisie obligatoire",
          "Know Your Client Risk Tolerance is a required field":
            "Tol\u00e9rance de risque est une zone de saisie obligatoire",
          "Know your Client": "Connaissez votre client",
          "Know your Client Objectives are required fields":
            'Objectifs dans \\"Connaissez votre client\\" est une zone de saisie obligatoire',
          "L7N 3G2": "L7N 3G2",
          Label: "Label",
          Language: "Langue",
          "Language used to detail plan": "Langauge utilis\u00e9",
          "Last Contribution Date": "Derni\u00e8re date de d\u00e9p\u00f4t",
          "Last Name": "Nom de famille",
          "Less than 5": "Moin de 5 ans",
          Leveraging: "Endettement",
          Liabilities: "Passifs",
          "Licensed Province": "Province sous licence",
          Lifetime: "Cumulatif",
          "Lifetime Maximizer": "Maximizer Cumulatif",
          Lifetime_Limit:
            "Montants des d\u00e9p\u00f4ts d\u00e9passe plafond cumulatif de REEE de 50 000 $ avant les options d'assurance.",
          Limited: "Limit\u00e9e",
          "Loading...": "Chargement en cours ...",
          "Location and Type of Savings": "Endroit et type d'e\u0301pargnes",
          "Location of Savings": "Location of Savings",
          Lock: "Fermer",
          Low: "Low",
          M: "M",
          "M-1": "M-1",
          MM: "MM",
          "Make Default": "Make Default",
          Male: "Masculin",
          "Manage Dealing Reps.": "G\u00e9rer repr\u00e9sentant de courtier",
          "Manage Enrolments": "G\u00e9rer les formulaires",
          "Mandatory before %@": "Obligatoire avant %@",
          "Mandatory immediately": "Obligatoire imm\u00e9diatement",
          Manitoba: "Manitoba",
          Master: "Master",
          Maternity: "Maternit\u00e9",
          "Maternity / Parental Leave": "Conge\u0301 parental",
          "Maturity Date": "Date d'\u00e9ch\u00e9ance",
          "Maximum AIR MILES redemption for a Group plan is $%i per unit.  AIR MILES redemption amount has been adjusted.":
            "Le maximum de AIR MILES \u00e0 racheter pour un r\u00e9gime collectif est de %i $ par part. Le montant de r\u00e9demption de AIR MILES a \u00e9t\u00e9 ajust\u00e9",
          "Maximum AIR MILES redemption for a Self-Initiated plan is $%i.  AIR MILES redemption amount has been adjusted.":
            "Le maximum de AIR MILES \u00e0 racheter pour un r\u00e9gime individuel est de %i $ par part. Le montant de r\u00e9demption de AIR MILES a \u00e9t\u00e9 ajust\u00e9",
          "Maximum AIR MILES redemption for an Achievers plan is $%i per unit.  AIR MILES redemption amount has been adjusted.":
            "Le maximum de AIR MILES \u00e0 racheter pour un r\u00e9gime des performants est de %i $ par part. Le montant de r\u00e9demption de AIR MILES a \u00e9t\u00e9 ajust\u00e9",
          "Maximum carry forward grant room for this beneficiary is $%i.  The carry forward amount has been adjusted.":
            "Le montant maximum en terme de report de droits aux subventions pour ce b\u00e9n\u00e9ficiaire est de %i $. Le montant \u00e0 reporter a \u00e9t\u00e9 ajust\u00e9.",
          Medium: "Moyen",
          "Meet Subscriber": "Rencontrez abonn\u00e9",
          "Middle Name": "Second pr\u00e9nom",
          Miles: "Miles",
          "Miscellaneous (detail in notes)":
            "Divers (d\u00e9tail dans les notes)",
          "Miscellaneous (detail in notes) ":
            "Divers (d\u00e9tail dans les notes)",
          Miss: "Mlle.",
          "Missing Fields": "Zone de saisie manques",
          Mode: "Mode de d\u00e9p\u00f4t",
          ModeName: "ModeName",
          Monthly: "Mensuel",
          "Monthly Contribution": "Contribution mensuelle",
          "Monthly ESP contribution (excluding T-mode) cannot exceed":
            "Le montant mensuel (n\u2019applique pas au T-mode) ne peut pas d\u00e9passer",
          "Mortgage / Condo fees / Rent / Property Tax":
            "Hypoth\u00e8que/Frais de copropri\u00e9t\u00e9/ Loyer/Imp\u00f4t foncier",
          "Mortgage / Condo fees / Rent / Property Tax ":
            "Hypoth\u00e8que/Frais de copropri\u00e9t\u00e9/ Loyer/Imp\u00f4t foncier",
          Mr: "M.",
          Mrs: "Mme.",
          Ms: "Mgr.",
          N: "N",
          "N/A": "N/A",
          NO: "Non",
          Name: "Nom",
          "Name of Beneficiary": "Nom du b\u00e9n\u00e9ficiaire",
          "Name of School": "Nom de l'\u00e9cole",
          Nephew: "Neveu",
          Net: "Nette",
          "Net Savings": "Cotisations nettes",
          "Net Worth Picker": "Net Worth Picker",
          "New Brunswick": "Nouveau-Brunswick",
          "New Dealing Rep.": "New Dealing Rep.",
          "New Enrolment": "Nouveau formulaire",
          Newfoundland: "Terre-Neuve",
          "Next Contribution Date": "Date de d\u00e9p\u00f4t suivant",
          Niece: "Ni\u00e8ce",
          No: "Non",
          "No. of years of educational support":
            "Nombre d'ann\u00e9es estim\u00e9es soutien \u00e0 l'\u00e9ducation",
          None: "Aucune",
          Normal: "Normal",
          "Northwest Territories": "Territoires du Nord-Ouest",
          "Not Applicable": "Non applicable",
          "Not Captured": "Non captur\u00e9",
          "Not Complete": "Not Complete",
          "Not Provided": "Non fourni",
          "Not Signed": "Non sign\u00e9",
          "Not related": "Non apparent\u00e9",
          "Not to seek employment": "Ne recherche pas d\u2019emploi",
          "Note deposit schedule and subscriber's 80th birthday":
            "Note deposit schedule and subscriber's 80th birthday",
          Notes: "Notes",
          "Notez le calendrier de d\u00e9p\u00f4ts et le 80e anniversaire du souscripteur":
            "Notez le calendrier de d\u00e9p\u00f4ts et le 80e anniversaire du souscripteur",
          "Nova Scotia": "Nouvelle-\u00c9cosse",
          Number: "Nombre",
          "Number of Additional Contributions Required":
            "Nombre de d\u00e9p\u00f4ts additionnels exig\u00e9",
          "Number of Dependants": "Nombre de personnes \u00e0 charge",
          "Number of Dependants Purchasing Scholarship Plans":
            "Personnes \u00e0 charge achetant des conventions de bourses",
          "Number of Units": "Nombre de parts",
          Nunavut: "Nunavut",
          OFF: "Non",
          OK: "OK",
          ON: "ON",
          Objective: "Objectif",
          Objectives: "Objectifs",
          Occupation: "Occupation",
          "Office Visit": "Visite au bureau",
          "Once an enrolment is sealed, it can no longer be changed and must be uploaded to Head Office in a timely manner.  Please be certain the enrolment is complete before sealing.":
            "Soumettre le dossier de candidature pour le traitement.",
          "One-Time": "Unique",
          "Ongoing Deposit Method": "Mode de d\u00e9p\u00f4t continu",
          OngoingDepoistMethod: "OngoingDepoistMethod",
          Ontario: "Ontario",
          Optional: "Optionnel",
          Other: "Autre",
          "Other (Specify in Notes)": "Autre (sp\u00e9cifier dans les notes)",
          "Other Assets": "Autres actifs",
          "Other Contractual Obligations": "Autres obligations contractuelles",
          "Other Contractual Obligations  ":
            "Autres obligations contractuelles",
          "Other Income": "Autre revenue",
          "Other form": "Autre formulaire",
          "Overall Progress": "Progression g\u00e9n\u00e9rale",
          "PCG First Name": "PCG First Name",
          "PCG Last Name": "PCG Last Name",
          PLUS: "PLUS",
          "PO Box": "B.P.",
          "PO Box %@": "B.P. %@",
          Passport: "Passeport",
          Password: "Mot de passe",
          Payment: "Paiement",
          "Payment Protection Insurance": "Assurance de maintien des paiements",
          "Payments on Loans and Debts":
            "Paiements sur les pr\u00eats et cr\u00e9ances",
          "Payments on Loans and Debts ":
            "Paiements sur les pr\u00eats et cr\u00e9ances",
          "Personal Meeting": "Rencontre personnelle",
          "Phone Number": "Numero de Telephone",
          "Plan Contribution Target": "L\u2019objectif de cotisation au plan",
          "Plan Illustration": "Illustration r\u00e9gime",
          "Plan Illustration Estimate -":
            "Estimations de l’illustration du régime -",
          "Plan Illustration Estimate - ":
            "Estimations de l’illustration du régime - ",
          "Plan Information": "Information sur le r\u00e9gime",
          "Plan Options": "Options du r\u00e9gime",
          "Plan Selection": "S\u00e9lection r\u00e9gime",
          "Plan Type": "Type de r\u00e9gime",
          "Plan Warning": "Avertissement",
          "Plan at Maturity": "R\u00e9gime \u00e0 l'\u00e9ch\u00e9ance",
          Plan_Mature:
            "Le r\u00e9gime viendra \u00e0 \u00e9ch\u00e9ance le %@, l\u2019ann\u00e9e o\u00f9 %@ atteindra le %@ anniversaire de sa naissance.",
          "Please read page 2 for the assumptions and important information used in preparing this illustration.":
            "Veuillez vous référer à la page 2 pour les hypothèses et les informations importantes utilisées dans la préparation de cette illustration.",
          "Please read page 2 for the assumptions and important information used in preparing this illustration.":
            "Veuillez vous référer à la page 2 pour les hypothèses et les informations importantes utilisées dans la préparation de cette illustration.",
          "Please upload all signed enrolments before upgrading.":
            "S'il vous pla\u00eet t\u00e9l\u00e9charger toutes les inscriptions sign\u00e9s avant la mise \u00e0 niveau.",
          "Postal Code": "Code postal",
          "Practice In": "Practice In",
          PracticeOut: "PracticeOut",
          "Pre-Authorized Payment": "Pre-Authorized Payment",
          "Prefered language": "Langue pr\u00e9f\u00e9r\u00e9e",
          "Preferred Language": "Langue pr\u00e9f\u00e9r\u00e9e",
          "Prepared By": "Pr\u00e9par\u00e9 par",
          "Prepared For": "Pr\u00e9par\u00e9 pour",
          "Previous Agreement Number": "Num\u00e9ro de la convention ",
          "Primary Care Giver": "Responsable du bénéficiaire",
          "Primary Care Giver_B": "Renseignements sur le responsable",
          "Prince Edward Island": "\u00cele-du-Prince-\u00c9douard",
          Print: "Imprimer",
          "Processing fee of 2% for Visa and Mastercard, 3% for AMEX will apply. The applicable fee will be automatically added at the time of the processing.":
            "Des frais de traitement de 2% pour Visa et Mastercard, 3% pour Amex s'appiquent. Les frais applicables seront automaticquement ajout\u00e9s au moment de la transaction.",
          Production: "Production",
          "Projected Estimated Amount*": "Prévision du montant approximatif*",
          "Projected Estimated Amount available in your Achievers Plan when your child is ready to attend post-secondary: ":
            "Montant estimatif projeté disponible dans votre régime Achievers lorsque votre enfant sera prêt à fréquenter un établissement postsecondaire : ",
          "Projected Estimated Amount available in your Group Option Plan when your child is ready to attend post-secondary: ":
            "Prévision du montant approximatif disponible dans votre régime collectif lorsque votre enfant sera prêt à effectuer des études postsecondaires : ",
          "Projected Estimated Amount available in your Self-Initiated Option Plan when your child is ready to attend post-secondary: ":
            "Montant estimatif projeté disponible dans votre régime Option Autonome lorsque votre enfant sera prêt à fréquenter un établissement postsecondaire : ",
          "Projection Interest Rate": "Taux d'int\u00e9r\u00eat projection",
          "Proof of Alberta Residency - Parent or Legal Guardian":
            "Proof of Alberta Residency - Parent or Legal Guardian",
          Prospectus: "Prospectus",
          "Prospectus Date": "Date de prospectus",
          "Prospectus Date is a required field":
            "Date du prospectus est une zone de saisie obligatoire",
          "Proudly Canadian. Over 30 years of helping you save for a brighter tomorrow.":
            "Fièrement Canadien. Plus de 30 ans d’aide à l’épargne pour un avenir meilleur.",
          Province: "Province",
          ProvincePicker: "ProvincePicker",
          "Provincial Grant": "Subventions provinciales",
          "Provincial Grant Income": "Revenu de subvention provincial",
          "Provincial Grants": "Subventions provinciales",
          QESI: "IQEE",
          "QESI Income": "Revenu IQEE",
          Quarterly: "Trimestriel",
          Quebec: "Qu\u00e9bec",
          "Quotation Details": "Devis d\u00e9tails",
          "Quote Based On": "Devis bas\u00e9 sur",
          "RESP Quotation": "Devis de REEE",
          "Redemption Instructions (optional)":
            "Directive concernat le remboursement pour transfert partiel (facultatif)",
          Relationship: "Relations",
          "Relationship Disclosure Information":
            "Document de divulgation de la nature de la relation",
          "Relationship Picker": "Relationship Picker",
          "Relationship to Subscriber": "Lien avec le souscripteur",
          "Relinquishing Beneficiary": "B\u00e9n\u00e9ficiaire c\u00e9dant",
          "Relinquishing Promoter": "Promoteur c\u00e9dant",
          "Relinquishing RESP has mulitple beneficiaries?":
            "REEE c\u00e9dant \u00e0 plusieurs b\u00e9n\u00e9ficiaires ?",
          "Relinquishing and receiving beneficiary are the same person?":
            "Les b\u00e9n\u00e9ficiaires c\u00e9dant et cessionnaire sont-ils la m\u00eame personne ?",
          "Remove Seal": "Retirer le joint",
          "Requested Deposit Date": "Date de d\u00e9p\u00f4t requise",
          RequestedDepositDate: "RequestedDepositDate",
          Required: "Exig\u00e9",
          Reset: "Remettre",
          "Restricted Client form": "Restricted Client formulaire",
          "Return of Sales Charge": "Remboursement de frais de souscription",
          "Return to previous employment":
            "Retour \u00e0 l\u2019emploi pr\u00e9c\u00e9dent",
          "Return to previous employment but with reduced hours":
            "Retour \u00e0 l\u2019emploi pr\u00e9c\u00e9dent mais avec des heures r\u00e9duites",
          "Revenu disponible depass\u00e9": "Revenu disponible dépassé",
          "Review Enrolment Forms": "Examen des formulaires",
          "Review Sealed Enrolment Forms":
            "Formulaires d'\u00e9valuation des effectifs scell\u00e9s",
          "Risk Tolerance": "Tol\u00e9rance risque",
          "Risk Tolerance Picker": "Risk Tolerance Picker",
          S: "S",
          "SAGES Grant": "Subvention SEEAS",
          SIN: "SIN",
          "SPS View Controller": "SPS View Controller",
          "Sales Charge": "Frais de souscription",
          Saskatchewan: "Saskatchewan",
          "Save Signatures & Exit": "Enregistrer Signatures & Exit",
          "Savings for RESP during maternity leave":
            "E\u0301pargnes disponibles pour financer les cotisations",
          "Scholarship Enhancement Fund Payments":
            "Paiements du Fond complémentaire de bourses d’études",
          "Seal Enrolment": "Soumettre",
          "Second Plan": "Deuxi\u00e8me r\u00e9gime",
          "Second Plan Payment": "Paiements du 2e r\u00e9gime",
          Sector: "Sector",
          Securities: "Titres",
          "Seek new employment": "Recherche de nouvel emploi",
          "Select a dealing rep. to manage on the left.":
            "S\u00e9lectionnez un repr\u00e9sentant de courti\u00e9 \u00e0 g\u00e9rer sur la gauche.",
          "Select an application to manage on the left.":
            "Select an application to manage on the left.",
          "Self-Initiated": "R\u00e9gime individuel",
          "Self-Initiated Option Plan Disclosure":
            "Divulgation - R\u00e9gime individuel",
          "Self-Initiated Option Plan": "R\u00e9gime individuel",
          "Self-Initiated Plan": "R\u00e9gime individuel",
          "Semi-Annually": "Semi-annuel",
          "Serial Number": "Num\u00e9ro de s\u00e9rie",
          "Service Promise": "Promesses de service",
          "Signatures will be discarded and need to be resigned, however enrolment details can be edited. ":
            "Les signatures seront perdus, mais les documents \\ Ncan \u00eatre recr\u00e9\u00e9e sans signatures.",
          "Signed (Upload Required)": "Sign\u00e9 (Upload Requis)",
          "Signed (Upload Required) [%i]": "Sign\u00e9 (Upload Requis) [%i]",
          Single: "Seul",
          Sir: "Sir",
          "Social Insurance Number": "Num\u00e9ro d'assurance sociale",
          Son: "Fils",
          "Source of Income": "Source de revenu",
          "Specify why if no end date":
            "Indiquer pourquoi si aucune date de fin",
          "Spouse or Common Law of PCG": "Conjoint du Responsable",
          Status: "Status",
          StatusID: "StatusID",
          "Store Size: %d megs": "Taille m\u00e9moire: 23 Mo",
          Street: "Rue",
          "Street Address": "Street Address",
          SubIDType: "SubIDType",
          Subscriber: "Souscripteur",
          "Subscriber 1": "Souscripteur 1",
          "Subscriber 1 E-Mail address is a required field":
            "Adresse courriel du Souscripteur 1 est une zone de saisie obligatoire",
          "Subscriber 1 Family Name": "Subscriber 1 Family Name",
          "Subscriber 1 First Name": "Subscriber 1 First Name",
          "Subscriber 1 Investment Experience is a required field":
            "Exp\u00e9rience en placement pour Souscripteur 1 est une zone de saisie obligatoire",
          "Subscriber 1 Last Name": "Subscriber 1 Last Name",
          "Subscriber 1 Name": "Subscriber 1 Name",
          "Subscriber 2": "Souscripteur 2",
          "Mobile Phone Number": "Numéro de téléphone portable",
          "Signing Method": "Méthode de signature",
          "Bank Name": "Nom de la banque",
          "Presets...": "Préréglages...",
          "In Person": "En personne",
          Remote: "Télécommande",
          "Subscriber 2 E-Mail address is a required field":
            "Adresse courriel du Souscripteur 2 est une zone de saisie obligatoire",
          "Subscriber 2 Family Name": "Subscriber 2 Family Name",
          "Subscriber 2 First Name": "Subscriber 2 First Name",
          "Subscriber 2 Investment Experience is a required field":
            "Exp\u00e9rience en placement pour Souscripteur 2 est une zone de saisie obligatoire",
          "Subscriber 2 Last Name": "Subscriber 2 Last Name",
          "Subscriber 2 Name": "Souscripteur 2 Nom",
          Subscribers: "Souscripteurs",
          "Subscriber(s)": "Souscripteur(s)",
          "Was the sales presentation conducted, in whole or in part, in a third language?":
            "La présentation de vente a-t-elle été effectuée, en tout ou en partie, dans une troisième langue ?",
          "Subscribers names": "Subscribers names",
          "Subscription Type": "Type d'abonnement",
          Subtitle: "Subtitle",
          Suite: "App.",
          "Supplemental Know your Client": "Connaissez votre client",
          "Tech suport mode": "Tech suport mode",
          "Technical Support": "Technical Support",
          "Technical Support Mode": "Technical Support Mode",
          "Technical Support Only": "Technical Support Only",
          "Telephone Call": "Appel t\u00e9l\u00e9phone",
          "Temporary Income (CCB, CERB, ETC)": "ACE",
          "Temporary SIN Disclosure":
            "Divulgation temporaire d'assurance sociale",
          "Thank you for your participation in the Children's Education Trust":
            "Nous vous remercions de votre participation \u00e0 les Fonds d'\u00e9tudes pour les enfants Inc.",
          "The above named person must be a parent or legal guardian of the Beneficiary of this application, and they must provide proof that they meet the Alberta Residency Requirement.":
            "The above named person must be a parent or legal guardian of the Beneficiary of this application, and they must provide proof that they meet the Alberta Residency Requirement.",
          "The beneficiary": "Le b\u00e9n\u00e9ficiaire",
          "The enrolment cannot be unsealed because one of the additional beneficiary enrolments is currently sealed.  Unseal all additioal benenficairies before you can unseal the first beneificary.":
            "L'inscription ne peut pas \u00eatre descell\u00e9e parce que l'inscription de l\u2019un des b\u00e9n\u00e9ficiaires suppl\u00e9mentaires est actuellement scell\u00e9e. Desceller tous les b\u00e9n\u00e9ficiaires suppl\u00e9mentaires avant de pouvoir desceller le premier b\u00e9n\u00e9ficiaire",
          "The enrolment is not sealed": "L'inscription n'est pas scell\u00e9",
          "The first and additional plan must be of the same type.":
            "Le premier et le deuxi\u00e8me r\u00e9gime doit \u00eatre du m\u00eame type.",
          "The plan will mature on [date] when the beneficiary is [x] years old.":
            "The plan will mature on [date] when the beneficiary is [x] years old.",
          "There was an error loading the CEFI iPad App.  Tap Continue, if the problem persists tap Upload error to head office and contact Agent Services":
            "There was an error loading the CEFI iPad App.  Tap Continue, if the problem persists tap Upload error to head office and contact Agent Services",
          "Third Language Form": "Formulaire de troisi\u00e8me langue",
          "Third Party Financial Support Form":
            "Divulgation d\u2019appui financier par une tierce partie",
          "This enrolment cannot be deleted because it is already sealed.":
            "Cette inscription ne peut pas \u00eatre supprim\u00e9e parce qu\u2019elle est d\u00e9j\u00e0 scell\u00e9e",
          "This enrolment cannot be deleted because it is the first enrolment of a family enrolment.  You must delete the additional beneficiary enrolments first.":
            "Cette inscription ne peut pas \u00eatre supprim\u00e9e parce qu\u2019elle est la premi\u00e8re inscription de la famille. Vous devez d\u2019abord supprimer les inscriptions des b\u00e9n\u00e9ficiaires suppl\u00e9mentaires",
          "This enrolment cannot be unsealed because it has been uploaded to head office already.  Please contact your branch manager if there are problems with this enrolment.":
            "Cette inscription ne peut pas \u00eatre descell\u00e9e, parce qu\u2019elle a \u00e9t\u00e9 d\u00e9j\u00e0 t\u00e9l\u00e9charg\u00e9e vers le si\u00e8ge social. Veuillez contacter votre directeur de succursale s'il y a des probl\u00e8mes avec cette inscription",
          "This enrolment cannot be unsealed because the upload to head office was initiated.  Please complete the upload and contact your branch manager if there are problems with this enrolment.":
            "Cette inscription ne peut pas \u00eatre descell\u00e9e, car le t\u00e9l\u00e9chargement vers le si\u00e8ge social a \u00e9t\u00e9 lanc\u00e9. Veuillez compl\u00e9ter le t\u00e9l\u00e9chargement et contacter votre directeur de succursale s'il y a des probl\u00e8mes avec cette inscription",
          "This enrolment cannot be uploaded because has already been uploaded to head office.":
            "Cette inscription ne peut pas \u00eatre t\u00e9l\u00e9charg\u00e9e parce qu\u2019elle a d\u00e9j\u00e0 \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9e vers le si\u00e8ge social",
          "This enrolment cannot be uploaded because it is not sealed.":
            "This enrolment cannot be uploaded because it is not sealed.",
          "This enrolment cannot be uploaded until all the enrolments in the family have been sealed.":
            "Cette inscription ne peut pas \u00eatre t\u00e9l\u00e9charg\u00e9e tant que toutes les inscriptions dans la famille n\u2019auront pas \u00e9t\u00e9 scell\u00e9es",
          "This enrolment is in the process of being uploaded and cannot be unsealed.":
            "Cette inscription est en train d'\u00eatre t\u00e9l\u00e9charg\u00e9e et ne peut pas \u00eatre descell\u00e9e",
          "This enrolment is not sealed.":
            "Cette inscription n'est pas scell\u00e9.",
          "This enrolment may not be signed and sealed at this time.  Required fields are missing from this enrolment":
            "Cette inscription ne peut \u00eatre ni sign\u00e9e ni scell\u00e9e \u00e0 ce moment. Les zones de saisie obligatoire sont vides dans cette inscription",
          "This enrolment may not be signed and sealed at this time.  The 1st enrolment for the family must be signed before the additional enrolments":
            "Cette inscription ne peut \u00eatre sign\u00e9 et scell\u00e9 \u00e0 ce moment. L'inscription 1er pour la famille doit \u00eatre sign\u00e9 avant que les inscriptions suppl\u00e9mentaires",
          "Time Horizon": "Horizon temporel",
          Title: "Titre",
          "Tony Rogers": "Tony Rogers",
          "Top Up": "Augmentation",
          "Total Contributions": "Cotisations totales",
          "Total Financial Assets": "Total des actifs financiers",
          "Total Net Contributions": "Cotisations nettes",
          select: "s\u00e9lectionner",
          Transfer: "Transfert",
          "Transfer Amount": "Montant de tranf\u00e9rer",
          "Transfer CLB Amount": "Montant de BEC \u00e0 tranf\u00e9rer",
          "Transfer Department": "Transfer Department",
          "Transfer Details": "D\u00e9tails du transfert",
          "Transfer balance of account?": "Le solde de mon compte ?",
          Transit: "Transit",
          Transportation: "Transport",
          "Transportation ": "Transport",
          "Trusted Contact Person": "Personne-ressource de confiance",
          "Type of ID": "Genre d'identification",
          "Type of Identification": "Genre d'identification",
          "Type of Identification/Proof": "Type of Identification/Proof",
          'UILabel"; tex': 'UILabel"; tex',
          Units: "Parts",
          "Unknown Status": "Statut inconnu",
          "Unknown signature status - contact support":
            "Statut de Signature inconnue \u2013 Contactez l\u2019assistance technique",
          Unseal: "Desceller",
          "Unseal Enrolment": "Unseal Enrolment",
          "Unsealing this enrolment will discard all it's signatures but allow you to edit the contents of the enrolment.  Do you wish to proceed?":
            "Desceller cette inscription supprimera toutes ses signatures, mais vous permettra de modifier le contenu de l'inscription. Souhaitez-vous continuer ?",
          "Upgrade Available": "R\u00e9viser disponible",
          Upload: "T\u00e9l\u00e9chargez",
          "Upload error to head office":
            "T\u00e9l\u00e9chargez erreur au si\u00e8ge social",
          "Uploaded to Head Office": "Envoy\u00e9 au si\u00e8ge social",
          "Uploading %d of %d": "Transfert %d de %d",
          "Uploading 1 of 10": "Uploading 1 of 10",
          "Use iTunes File Sharing to retrieve the enrolment package for %@ %@.":
            "Utilisez le Partage de fichiers iTunes %@ %@ pour extraire la trousse d'inscription",
          Utilities: "Services publics",
          "Validation Code": "Validation Code",
          "Validation Date": "Validation Date",
          "Value of Benefits": "Valeur des avantages",
          "Vehicle Picker": "Vehicle Picker",
          "Vehicle(s) owned or being paid for?":
            "Nombre de v\u00e9hicules pay\u00e9s ou en voie de paiement ?",
          "Version X.x": "Version X.x",
          "Version x.xx": "Version x.xx",
          "Version: %@ %@": "Version: %@ %@",
          Warning: "Avertissement",
          "Warning!": "Avertissement!",
          Warnings: "Avertissements",
          "We believe you have made a wise and prudent decision.":
            "Nous croyons que vous avez pris une d\u00e9cision sage et prudente",
          "When did financial support begin?":
            "Quand l\u2019aide financi\u00e8re a-t-elle commenc\u00e9e ?",
          "Would you like to copy the payment information from the first beneficiary? This will overwrite payment information entered for this beneficiary.":
            "Voulez-vous copier les informations de paiement du b\u00e9n\u00e9ficiaire en premier ? Cela va \u00e9craser les informations de paiement conclu pour ce b\u00e9n\u00e9ficiaire.",
          X: "X",
          "XML Blob": "XML Blob",
          Y: "O",
          YES: "YES",
          YY: "YY",
          YYYY: "AAAA",
          "Year of Eligibility": "Ann\u00e9e d'admissibilit\u00e9",
          Yearly: "Annuel",
          "Yearly CESG Maximum": "SCEE Annuel Maximum",
          "Yearly Contribution Amount": "Montant de cotisations annuel",
          Yes: "Oui",
          "You do not have email configured on your iPad.":
            "Vous n'avez pas de messagerie configur\u00e9 sur votre iPad.",
          "You may Discard all signatures and edit this enrolment. You may Save signatures and add signing at a later time.  You may also Continue signing. ":
            "Vous pouvez jeter toutes les signatures et modifier cette inscription. Vous pouvez enregistrer les signatures et ajouter la signature \u00e0 une date ult\u00e9rieure. Vous pouvez \u00e9galement Continuer signature.",
          "Your DR code %@ is not licensed in the province %@.":
            "Votre code %@ n'est pas autoris\u00e9 dans la province %@",
          "Your contributions will earn you 100 AIR MILES Reward miles!":
            "Your contributions will earn you  100 AIR MILES Reward miles!",
          "Your contributions will earn you 100 AIR MILES Reward miles over the life of the plan!":
            "Your contributions will earn you  100 AIR MILES Reward miles over the life of the plan!",
          "Your contributions will earn you %i AIR MILES Reward Miles over the life of the plan!":
            "Vos cotisations vous feront gagner %i milles de r\u00e9compense AIR MILES durant la  dur\u00e9e de vie du r\u00e9gime!",
          "Your contributions will earn you %i AIR MILES\u00ae Reward Miles over the life of the plan!":
            "Vos cotisations vous rapporteront %i milles de r\u00e9compense AIR MILES pendant la dur\u00e9e du r\u00e9gime!",
          "Your plan has been set up for the beneficiary to commence post-secondary study in %i, during the year of the beneficiary's %ith birthday.":
            "Votre r\u00e9gime a \u00e9t\u00e9 mis en place de telle sorte que le  b\u00e9n\u00e9ficiaire commence ses \u00e9tudes postsecondaires en %i, au cours de l\u2019ann\u00e9e du %ie anniversaire du b\u00e9n\u00e9ficiaire.",
          "Your plan has been set up for the beneficiary to commence post-secondary study in 2030,  during the year of the beneficiary's 18th birthday.":
            "Your plan has been set up for the beneficiary to commence post-secondary study in 2030,  during the year of the beneficiary's 18th birthday.",
          "Yukon Territories": "Territoire du Yukon",
          account: "account",
          address: "address",
          agents: "agents",
          agreement: "agreement",
          "air miles": "air miles",
          airMilesCell: "airMilesCell",
          airMilescell: "airMilescell",
          airmiles: "airmiles",
          albertaGrant: "albertaGrant",
          "application_to_KnowYourClient.riskTolerance":
            "application_to_KnowYourClient.riskTolerance",
          "application_to_KnowYourClient.drReason":
            "application_to_KnowYourClient.drReason",
          "application_to_Subscriber1.investmentExperience":
            "application_to_Subscriber1.investmentExperience",
          "application_to_Subscriber2.investmentExperience":
            "application_to_Subscriber2.investmentExperience",
          approxNetWorth: "grantRoom",
          "approximate net worth": "Valeur nette approximative",
          bank: "Banque",
          basic: "basic",
          "bene dob": "bene dob",
          "bene first": "bene first",
          "bene gender": "bene gender",
          "bene last": "bene last",
          "bene middle": "bene middle",
          "bene name": "bene name",
          "bene sin": "bene sin",
          beneFirstName: "beneFirstName",
          beneLastName: "beneLastName",
          beneficiary: "beneficiary",
          "beneficiary 0": "beneficiary 0",
          "beneficiary 1": "beneficiary 1",
          "beneficiary 2": "beneficiary 2",
          "beneficiary 3": "beneficiary 3",
          "beneficiary 4": "beneficiary 4",
          "beneficiary 5": "beneficiary 5",
          "business phone": "business phone",
          cert: "cert",
          cesg: "cesg",
          city: "city",
          clb: "clb",
          closeConfiguration: "closeConfiguration",
          clothing: "clothing",
          completion: "completion",
          country: "country",
          "cp name": "cp name",
          "credit card number": "credit card number",
          "credit card type": "credit card type",
          "critical illness": "critical illness",
          "custodian email": "custodian email",
          "custodian gender": "custodian gender",
          depositAmount: "depositAmount",
          depositCodeDynamic: "depositCodeDynamic",
          depositCodeStatic: "depositCodeStatic",
          depositMode: "depositMode",
          deposits: "grantRoom",
          drFullName: "drFullName",
          effectiveDate: "effectiveDate",
          electronicConsent: "electronicConsent",
          email: "email",
          "enrol another beneficiary": "enrol another beneficiary",
          existingPreAuthorizedDeposits: "existingPreAuthorizedDeposits",
          expiry: "expiry",
          firstPlan: "firstPlan",
          formDate: "formDate",
          grantRoom: "grantRoom",
          groceries: "groceries",
          guardian: "guardian",
          "home phone": "home phone",
          knowYourClient: "knowYourClient",
          liabilities: "grantRoom",
          loans: "loans",
          lock0: "lock0",
          lock1: "lock1",
          lock2: "lock2",
          lock3: "lock3",
          lock4: "lock4",
          lock5: "lock5",
          lock6: "lock6",
          lock7: "lock7",
          lock8: "lock8",
          lock9: "lock9",
          lockok: "lockok",
          lockreset: "lockreset",
          manageDealingReps: "manageDealingReps",
          manageEnrolment: "manageEnrolment",
          maturityDateDynamic: "maturityDateDynamic",
          maturityDateStatic: "maturityDateStatic",
          miscellaneous: "miscellaneous",
          mm: "mm",
          "mm/dd/yyyy": "mm/dd/yyyy",
          morgage: "morgage",
          newEnrolment: "newEnrolment",
          "number of dependants": "number of dependants",
          "other contractual": "other contractual",
          "other gross": "other gross",
          "other income": "other income",
          "other net": "other net",
          otherAssets: "grantRoom",
          "p1 deposit date": "p1 deposit date",
          "p1 initial deposit": "p1 initial deposit",
          "p1 initial method": "p1 initial method",
          "p1 ongoing method": "p1 ongoing method",
          "p2 deposit date": "p2 deposit date",
          "p2 initial deposit": "p2 initial deposit",
          "p2 initial method": "p2 initial method",
          "p2 ongoing method": "p2 ongoing method",
          "pap bank": "pap bank",
          payment: "payment",
          "payment protection": "payment protection",
          "plan type": "plan type",
          plb: "plb",
          pobox: "pobox",
          "postal code": "postal code",
          production: "production",
          province: "province",
          "quote based on": "quote based on",
          quoteBasedOn: "quoteBasedOn",
          relationship: "relationship",
          "remove seal": "remove seal",
          reviewEnrolmentForms: "reviewEnrolmentForms",
          reviewSealedEnrolmentForms: "reviewSealedEnrolmentForms",
          "risk tolerance": "risk tolerance",
          s: "s",
          "s1 dob": "s1 dob",
          "s1 email": "s1 email",
          "s1 email address": "s1 email address",
          "s1 employer": "s1 employer",
          "s1 employer address": "s1 employer address",
          "s1 employer industry": "s1 employer industry",
          "s1 first": "s1 first",
          "s1 gender": "s1 gender",
          "s1 gross": "s1 gross",
          "s1 how did you meet the dr": "s1 how did you meet the dr",
          "s1 id": "s1 id",
          "s1 idtype": "s1 idtype",
          "s1 income": "s1 income",
          "s1 investment experience": "s1 investment experience",
          "s1 last": "s1 last",
          "s1 meet dr": "s1 meet dr",
          "s1 middle": "s1 middle",
          "s1 name": "s1 name",
          "s1 net": "s1 net",
          "s1 occupation": "s1 occupation",
          "s1 pcg": "s1 pcg",
          "s1 sin": "s1 sin",
          "s1 title": "s1 title",
          "s2 dob": "s2 dob",
          "s2 email": "s2 email",
          "s2 email address": "s2 email address",
          "s2 employer": "s2 employer",
          "s2 employer address": "s2 employer address",
          "s2 employer industry": "s2 employer industry",
          "s2 first": "s2 first",
          "s2 gender": "s2 gender",
          "s2 gross": "s2 gross",
          "s2 id": "s2 id",
          "s2 idtype": "s2 idtype",
          "s2 income": "s2 income",
          "s2 investment experience": "s2 investment experience",
          "s2 last": "s2 last",
          "s2 middle": "s2 middle",
          "s2 name": "s2 name",
          "s2 net": "s2 net",
          "s2 occupation": "s2 occupation",
          "s2 pcg": "s2 pcg",
          "s2 sin": "s2 sin",
          "s2 title": "s2 title",
          secondPlan: "secondPlan",
          securities: "grantRoom",
          size: "size",
          "special instructions": "special instructions",
          "street number": "street number",
          subFullName: "subFullName",
          subFullName2: "subFullName2",
          subscriber: "subscriber",
          subscriber1FirstName: "subscriber1FirstName",
          subscriber1LastName: "subscriber1LastName",
          subscriber2FirstName: "subscriber2FirstName",
          suite: "suite",
          "support mode": "support mode",
          switch_Deposit: "switch_DepositF",
          switch_Dollars: "switch_DollarsF",
          switch_English: "switch_EnglishF",
          switch_Female: "switch_FemaleF",
          switch_French: "switch_FrenchF",
          switch_Joint: "switch_JointF",
          switch_Male: "switch_MaleF",
          switch_Miles: "switch_MilesF",
          switch_No: "switch_NoF",
          switch_Single: "switch_SingleF",
          switch_Units: "switch_UnitsF",
          switch_Yes: "switch_YesF",
          techSupportMode: "techSupportMode",
          testAgents: "testAgents",
          "the beneficiary": "le b\u00e9n\u00e9ficiaire",
          thirdPartyApproxNetWorth: "thirdPartyApproxNetWorth",
          thirdPartyBegin: "thirdPartyBegin",
          thirdPartyBirthdate: "thirdPartyBirthdate",
          thirdPartyDetail: "thirdPartyDetail",
          thirdPartyDisposableIncome: "thirdPartyDisposableIncome",
          thirdPartyDocumentation: "thirdPartyDocumentation",
          thirdPartyEndDate: "thirdPartyEndDate",
          thirdPartyHomeAddress: "thirdPartyHomeAddress",
          thirdPartyIdExpiry: "thirdPartyIdExpiry",
          thirdPartyIdNumber: "thirdPartyIdNumber",
          thirdPartyIdType: "thirdPartyIdType",
          thirdPartyIncome: "thirdPartyIncome",
          thirdPartyIncomeSource: "thirdPartyIncomeSource",
          thirdPartyName: "thirdPartyName",
          thirdPartyNoEndReason: "thirdPartyNoEndReason",
          thirdPartyRelationship: "thirdPartyRelationship",
          "time horizon": "horizon temporel",
          totalFinancialAssets: "grantRoom",
          answer: "s\u00e9lectionner",
          "select a title": "s\u00e9lectionner",
          "select agent": "s\u00e9lectionner",
          "select birth date": "s\u00e9lectionner",
          "select card type": "s\u00e9lectionner",
          "select code": "s\u00e9lectionner",
          "select date": "s\u00e9lectionner",
          "select experience": "s\u00e9lectionner",
          "select form type": "s\u00e9lectionner",
          "select identification": "s\u00e9lectionner",
          "select method": "s\u00e9lectionner",
          "select mode": "s\u00e9lectionner",
          "select objective": "s\u00e9lectionner",
          "select plan": "s\u00e9lectionner",
          "select province": "s\u00e9lectionner",
          "select risk tolerance": "s\u00e9lectionner",
          "select vehicles": "s\u00e9lectionner",
          "1st of the month": "1er du mois",
          "8th of the month": "8e du mois",
          "15th of the month": "15e du mois",
          "22nd of the month": "22e du mois",

          "28th of the month": "28e du mois",
          "select years": "s\u00e9lectionner",
          "Select an option": "s\u00e9lectionner",
          "Select option": "s\u00e9lectionner",
          "set date": "s\u00e9lectionner",
          "set date of birth": "s\u00e9lectionner",
          transfer: "transfer",
          transit: "transit",
          transportation: "transportation",
          units: "units",
          upgrade: "upgrade",
          yy: "yy",
          "yyyy/mm/dd": "yyyy/mm/dd",
          "yyyy/mm/ddd": "yyyy/mm/ddd",
          "\u2605\u2605\u2605\u2605\u2605": "\u2605\u2605\u2605\u2605\u2605",
          "\u2713": "\u2713",
          "--Select One--": "s\u00e9lectionner",
          "Select One": "s\u00e9lectionner",

          "Full Name": "Nom",
          "As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the subscriber.":
            "Par mesure de sécurité, un message écrit peut être envoyé à ce numéro au cours de la procédure de signature afin de vérifier l'identité du souscripteur.",
          "Transfer BCTESG Amount": "Transfert du montant de la SEEEFCB",
          "is a required field": "est un champ obligatoire",
          "validation errors found": "erreurs de validation détectées",
          "Enrolment Validated": "Inscription validée",
          "Awaiting Signatures": "Signatures attendues",
          "Signing Completed": "Signature terminée",
          "Enrollment Review": "Révision des inscriptions",
          "Know Your Client Approximate Net Worth is a required field":
            "Connaitre votre client Avoir net approximatif est un champ obligatoire",
          "Subscriber 1 Mobile Phone is a required field":
            "Souscripteur 1 Téléphone mobile est un champ obligatoire",
          "No enrolments found.": "Aucune adhésion n'a été trouvée.",
          "Completion insurance required": "Assurance de bonne fin requise",
          "As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the guardian.":
            "Par mesure de sécurité, un message texte peut être envoyé à ce numéro pendant la procédure de signature pour vérifier l'identité du tuteur.",
          "As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the joint subscriber.":
            "Par mesure de sécurité, un message texte peut être envoyé à ce numéro pendant la procédure de signature pour vérifier l'identité du co-souscripteur.",
          "As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the beneficiary.":
            "Par mesure de sécurité, un message texte peut être envoyé à ce numéro pendant la procédure de signature pour vérifier l'identité du bénéficiaire.",
          "Beneficiary name unknown": "Nom du bénéficiaire inconnu",
          "Last save attempt failed.":
            "La dernière tentative de sauvegarde a échoué.",
          "Changes saved!": "Changements sauvegardés !",
          "AIR Miles logo": "Logo AIR Miles",
          "Enrol Additional Beneficiary":
            "Adhésion d'un bénéficiaire supplémentaire",
          "You are currently viewing a secondary enrolment that is part of a Family Enrolment. The primary enrolment is shown below.":
            "Vous visionnez actuellement une adhésion secondaire qui fait partie d'une adhésion familiale. L'adhésion principale est indiquée ci-dessous.",
          "This enrolment is a secondary enrolment of a Family Enrolment. Know Your Client and Subscriber information must be completed on the primary enrolment.":
            "Cette adhésion est une adhésion secondaire d'une adhésion familiale. Les informations relatives à la connaissance du client et du souscripteur doivent être complétées sur l'adhésion principale.",
          "This enrolment is the primary enrolment of a Family Enrolment. Know Your Client and Subscriber details entered on this enrolment here will apply to all secondary enrolments.":
            "Cette adhésion est l'adhésion principale d'une adhésion familiale. Les informations relatives à la connaissance du client et du souscripteur saisies lors de cette adhésion s'appliqueront à toutes les adhésions secondaires.",
          "Know Your Client details must be changed on the Primary enrolment of this Family Enrolment.":
            "Les informations relatives à la connaissance du client doivent être modifiées dans l'adhésion principale de cette adhésion familiale.",
          "You are currently viewing the primary enrolment of a Family Enrolment. Secondary enrolments are shown below.":
            "Vous visionnez actuellement l'adhésion principale d'une adhésion familiale. Les adhésions secondaires sont indiquées ci-dessous.",
          "Know Your Client and Subscriber details can only be changed on the primary enrolment.":
            "Les informations relatives à la connaissance du client et du souscripteur ne peuvent être modifiées que dans l'adhésion principale.",
          "Subscriber details must be changed on the Primary enrolment of this Family Enrolment.":
            "Les coordonnées du souscripteur doivent être modifiées dans l'adhésion principale de cette adhésion familiale.",
          "This application is part of a Family Enrolment.  You must submit the primary enrolment for signing before you can submit this one.":
            "Cette demande fait partie d'une adhésion familiale.  Vous devez soumettre l'adhésion principale pour signature avant de pouvoir soumettre celle-ci.",
          "Jump to primary enrolment": "Passez à l'adhésion principale",
          "There are ${state.application.childApplicationIds.length} secondary enrolments that are part of this Family Enrolment.":
            "Il y a ${indiquer.demande.Identitedemandeenfant.durée} adhésions secondaires qui font partie de cette adhésion familiale.",
          "There is ${state.application.childApplicationIds.length} secondary enrolment that is part of this Family Enrolment.":
            "Il y a ${ indiquer.demande.Identitedemandeenfant.durée } adhésions secondaires qui font partie de cette adhésion familiale.",
          "Know Your Client and Subscriber details cannot be changed in secondary enrolments once the primary package is Sealed and Sent for Signatures.":
            "Les informations relatives à la connaissance du client et du souscripteur ne peuvent pas être modifiées dans les adhésions secondaires une fois que l'adhésion principale a été scellée et envoyée à la signature.",
          "This enrolment has been submitted for signing and can no longer be used to add more Family Enrolments.":
            "Cette adhésion a été soumise à la signature et ne peut plus être utilisée pour ajouter d'autres adhésions familiales.",
          "Generating PDF...": "Générer des PDF...",
          "more validation errors": "plus d'erreurs de validation",
          "more validation error": "plus d'erreur de validation",
          "Jump to input field": "Passez au champ de saisie",
          "Submitting enrolment documents...":
            "Soumission des documents d'adhésion...",
          "This is the primary enrolment of a Family Enrolment.":
            "Cette adhésion est la principale d'une adhésion d'une famille.",
          "Identity document verification":
            "Vérification des pièces d'identité",
          "Enrolment Review": "Révision de l'adhésion",
          "Fetching current document from DocuSign...":
            "Récupération du document actuel de DocuSign...",
          "Subscriber(s)": "Souscripteur(s)",
          "DR Checklist": "Liste de vérification du RC",
          "How did you meet the subscriber(s)?":
            "Comment avez-vous rencontré le(s) souscripteur(s) ?",
          "Enrolment Application has been reviewed with the Subscriber(s) by the Dealing Representative":
            "La demande d'adhésion a été examinée avec le(s) souscripteur(s) par le représentant de courtier.",
          "The most up to date version of the relevant CEFI plan presentation was presented by the undersigned DR in full.":
            "La version la plus récente de la présentation du plan du FEEI a été présentée dans son intégralité par le RC soussigné.",
          "Subscriber(s) has received an explanation of each of the following boxes on the Enrolment Application by the Dealing Representative: receipt of prospectus; sales charge explanation; RESP contribution limit":
            "Le(s) souscripteur(s) a (ont) reçu du représentant de courtier une explication sur chacune des cases suivantes de la demande d'adhésion: réception du prospectus, explications sur les frais de souscription, plafond de cotisation au REEE.",
          "RESP contribution limit": "Plafond de cotisation au REEE",
          "I have conducted a comprehensive Know Your Client discussion which is fully documented by the undersigned Dealing Representative using the appropriate KYC Form":
            "J'ai mené une discussion approfondie sur la connaissance du client qui est entièrement documentée par le représentant de courtier soussigné à l'aide du formulaire CVC approprié.",
          "The appropriate Plan Summary has been fully explained to the Subscriber(s) by the undersigned Dealing Representative.":
            "Le sommaire du régime approprié a été entièrement expliqué au(x) souscripteur(s) par le représentant de courtier soussigné.",
          "The Prospectus dated %@ was delivered to Subscriber(s).":
            "Le prospectus du %@ a été remis au(x) souscripteur(s).",
          "The Prospectus dated June 30, 2026 was delivered to Subscriber(s).":
            "Le prospectus du 30 juin 2026 a été remis au(x) souscripteur(s).",
          "Amendment No.1 dated June 15, 2026 was delivered to Subscriber(s).":
            "L'amendement no 1 daté du 15 Juin 2026 a été remis au(x) souscripteur(s).",
          "The Relationship Disclosure Information Form was discussed with and explained to the Subscriber(s).":
            "Le formulaire de divulgation de renseignements sur la relation a été fourni et expliqué au(x)souscripteur(s).",
          "The DR has physically inspected a valid form of identification as required and has inspected the SIN card/letter for the Subscriber(s) and Beneficiary for all SINs reported.":
            "Le représentant de courtier a procédé à une inspection matérielle d’une pièce d'identité valide comme requis et a examiné la carte ou la lettre du NAS pour le(s) souscripteur(s) et le bénéficiaire pour tous les NAS signalés.",
          "Applications for Government Grants were discussed with and explained to the Subscriber(s).":
            "Les demandes de subventions gouvernementales ont été discutées et expliquées au(x) souscripteur(s).",
          "If applicable – Disclosure of Grant Limits for Subscriber(s) Exceeding Contributions of $2,500 Per Year was discussed with and explained to the Subscriber(s). NOTE: Dealing Representative must take into consideration existing commitments for Subscriber(s) to determine whether combined contributions will exceed $2,500 per year in respect of the SAME beneficiary. If so, Grant Limits Disclosure MUST accompany Enrolment.":
            "S’il y a lieu – le formulaire de divulgation des limites de subventions pour les souscripteurs qui excèdent la limite de 2 500 $ par année a été discutées et expliquées au(x) souscripteur(s). NOTE : Le représentant de courtier doit tenir compte des engagements existants pour les souscripteurs pour déterminer si les cotisations combinées excèdent 2 500 $ par année en ce qui a trait au MÊME bénéficiaire. Si c’est le cas, le formulaire de divulgation des limites de subventions DOIT accompagner la demande d’adhésion.",
          "If applicable – Non-Resident Risk Disclosure discussed with and explained to the a prospective Subscriber(s) applying for a Registered Education Savings Group Plan with a temporary Social Insurance Number issued by the Government of Canada. If so, Non-Resident Risk Disclosure MUST accompany Enrolment.":
            "S’il y a lieu - le formulaire de divulgation de risque pour un non-résident a été discuté et expliqué aux souscripteurs potentiels qui font une demande d’adhésion à un régime enregistré d’épargne-études collectif avec un numéro d’assurance sociale temporaire émis par le gouvernement du Canada. Si c’est le cas, le formulaire de divulgation de risque pour un non-résident DOIT accompagner la demande d’adhésion.",
          "If applicable – Disclosure of Third Party Financial Support – Where a prospective Subscriber(s) confirm(s) that they receive regular ongoing financial support from a third party (e.g. regular ongoing income or subsidized living expenses by reason of sharing accommodation (i.e. multi-generational living arrangement)). If so, a Disclosure of Third Party Financial Support Form (signed by the Financial Supporter) MUST accompany Enrolment.":
            "S’il y a lieu - le formulaire de divulgation d’appui financier par une tierce partie- Lorsque les souscripteurs potentiels confirment qu’ils reçoivent un soutien financier continu et régulier d’un tiers (ex. revenu régulier et continu ou frais de subsistance subventionnés en raison du partage de l’hébergement (de mode de vie multigénérationnel). Si c’est le cas, le formulaire de divulgation d’appui financier par une tierce partie (signé par le bailleur de fonds) DOIT accompagner la demande d’adhésion.",
          "If applicable - Quebec Subscribers English only: I have provided the subscriber(s) a French version of the enrolment application for their consideration and review.":
            "S’il y a lieu –Seulement pour les souscripteurs anglophones du Québec- J'ai fourni au(x) souscripteur(s) une version française de la demande d'adhésion afin qu'il(s) l'examine(nt).",
          "If applicable – Dealing Representative 3rd Language Acknowledgment is completed & signed and dated by Dealing Representative when providing service or promoting the CET Plans to the Subscriber(s) in a language other than French or English.":
            "S’il y a lieu – Le formulaire « Reconnaissance d’une troisième langue par le représentant de courtier » est rempli, signé et daté par le représentant de courtier lorsqu'il s'agit de fournir des services ou de promouvoir les plans FEE au(x) souscripteur(s) dans une langue autre que le français ou l'anglais.",
          "Escrow Agreement, if required, discussed with and explained to the discussed with and explained to the Subscriber(s).":
            "S’il y a lieu, la convention d’entiercement a été discutée et expliquée au(x) souscripteur(s).",
          "Any changes on forms have been initialed by the Subscriber(s).":
            "Toutes les modifications sur les formulaires ont été paraphées par le ou les souscripteurs.",
          "For deposits made by cheque, the cheque is payable to “CHILDREN’S EDUCATION TRUST OF CANADA”, signed and current dated. NOTE: Cheques payable to the Children’s Education Funds Inc. or any payee other than the Children’s Education Trust of Canada will be rejected.":
            "Pour les dépôts faits par chèque, le chèque doit être libellé à la « FIDUCIE POUR L’ÉDUCATION DES ENFANTS DU CANADA », signé et daté d’aujourd’hui. NOTE : Les chèques libellés au Fonds d’étude pour les enfants Inc. ou à tout autre bénéficiaire, autre que la FIDUCIE POUR L’ÉDUCATION DES ENFANTS DU CANADA, seront rejetés.",
          "Any applicable Dual Licence or Outside Business Activity Disclosure(s) was fully discussed with and explained to the Subscriber(s).":
            "Le formulaire de divulgation de toute licence double applicable ou activités professionnelles extérieures a été dûment discuté et expliqué au(x) souscripteur(s).",
          "If insurance licensed: Optional Insurance form discussed with and explained to the Subscriber(s) in connection with the sale of optional insurance.":
            "Si titulaire d’une licence d’assurance : Formulaire d’assurance facultative discuté et expliqué au(x) souscripteur(s) en rapport avec la vente d'une assurance facultative.",
          "Non-Face-to-Face Enrolment – in addition to the items above, please confirm the following in the case of a Distance Enrolment":
            "Inscription à distance - en plus des éléments ci-dessus, veuillez confirmer ce qui suit dans le cas d’une inscription à distance:",
          "I confirm that a digital copy of the June 30, 2026 Prospectus has been sent to the Subscriber as an attachment to the MS Teams invitation to the virtual Subscriber meeting.":
            "Je confirme qu'une copie numérique du prospectus daté du 30 juin 2026 a été envoyée au souscripteur en pièce jointe à l'invitation MS Teams pour la réunion virtuelle des souscripteurs.",
          "I confirm that the CEFI Teams Background was used during the virtual meeting.":
            "Je confirme que l’arrière-plan FEEI a été utilisé lors de la rencontre à distance sur Teams.",
          "I confirm that each prospective subscriber scanned: • their authentic, valid and current (not expired) government issued photo identification to me for my review via their mobile phone or device; and, • SIN card or letter for the Subscriber(s) and Beneficiary.":
            "Je confirme que chaque souscripteur potentiel a scanné : sa pièce d’identité avec photo authentique, valide et actuelle (non expirée) émise par le gouvernement pour que je puisse l’examiner via son téléphone mobile ou autre appareil; et la carte ou la lettre du NAS pour le(s) souscripteur(s) et le bénéficiaire.",
          "I have duly recorded the identification number of the government issued photo identification and all SIN letters and cards that I inspected as required on the CEFI enrolment application in this manner. I have deleted the copy of the photo identification and SIN card/letter that I inspected in this manner.":
            "J’ai dûment enregistré le numéro d’identification de la pièce d’identité avec photo émise par le gouvernement et toutes les lettres et cartes du NAS que j’ai inspectées de cette manière tel que requis lors de la demande d’adhésion du FEEI. J’ai supprimé la copie de la pièce d’identité avec photo ainsi que la carte et lettre du NAS que j’ai inspectées de cette manière.",
          "I confirm that the photo identification presented to me as described above was inspected by me in accordance with CEFI’s Non-Face-to-Face Identification Verification policy.":
            "Je confirme que la pièce d’identité avec photo qui m’a été présentée de la manière décrite ci-dessus a été inspectée par moi conformément à la politique du FEEI sur la vérification de l’identification à distance.",
          "I engaged in a live videoconference with the subscriber(s) for the purpose of: A. Authenticating the name provided on the CEFI enrolment application by matching this name to the name provided on the digital copy of the government issued identification that I inspected; B. Authenticating the subscriber(s) facial image by matching their image to the photo provided on the digital copy of the government issued identification that I inspected; C. conducting this distance enrolment; and, D. delivering CEFI’s required plan presentation.":
            "J’ai participé à une vidéoconférence en direct avec le(s) souscripteur(s) dans le but de: a. Authentifier le nom fourni sur la demande d’adhésion du FEEI en faisant correspondre ce nom au nom fourni sur la copie numérique de la pièce d’identité émise par le gouvernement que j’ai inspectée; b. Authentifier l’image faciale du ou des souscripteurs en comparant l’image à la photo fournie sur la copie numérique de la pièce d’identité émise par le gouvernement que j’ai inspectée; c. effectuer cette inscription à distance; et, d. faire la présentation du plan tel que requis par le FEEI.",
          "Head office lead": "Responsable du siège social",
          "Existing subscriber": "Souscripteur existant",
          "Trade show/Advertisement": "Salon/Publicité",
          "Cheque Payable to:\nChildren's Education Trust":
            "Chéques à l'ordre de: Fiducie pour l'Éducation des Enfants",
          "Through a friend/subscriber":
            "Par l’intermédiaire d’un ami/souscripteur",
          "Breakdown of your Achievers Option Plan (Estimate)":
            "Détails de votre régime des performants (estimation)",
          "Amount Required on Next Contribution":
            "Montant requis lors de la prochaine cotisation",
          "Extra piece of the pie": "Part supplémentaire",
          "Enrichment Fund Payments (Top-Ups)":
            "Paiements au titre du fonds d'enrichissement (compléments)",
          "Total Sales Charge": "Frais de souscription totaux",
          "The chosen Achievers Plan Contribution Target is: ":
            "L'objectif de cotisation au Régime des performants choisi est : ",
          "An illustration of your Achievers Plan":
            "Une illustration de votre régime des performants",
          "Beneficiary Age on Dec. 31 of Maturity Year":
            "Âge du bénéficiaire au 31 décembre de l'année d'échéance",
          "Guardian Mobile Phone is a required field":
            "Téléphone portable du tuteur est un champ obligatoire",
          "This enrolment has been submitted to DocuSign and can no longer be edited.":
            "Cette adhésion a été soumise à DocuSign et ne peut plus être modifiée.",
          "Subscriber 2 Mobile Phone is a required field":
            "Téléphone portable du souscripteur 2 est un champ obligatoire",
          "Guardian E-Mail Address is a required field":
            "Adresse courriel du tuteur est un champ obligatoire",
          "Financial Information": "Renseignements financiers",
          "Cash and Other Liquid Investments":
            "Encaisse et autres placements liquides",
          "Investment Assets (Medium to Long-Term)":
            "Actifs de placement (moyen à long terme)",
          "Securities (Stocks/Bonds/Mutual Funds/ETFs)":
            "Valeurs (actions/obligations/fonds/FNB)",
          "Registered Accounts (RRSP & TFSA)":
            "Comptes enregistrés (REER et CELI)",
          "Registered Accounts (RESPs)": "Comptes enregistrés (REEE)",
          "Total Investment Assets": "Total des actifs de placement",
          "Other Assets (Real & Personal Property)":
            "Autres actifs (biens immobiliers et personnels)",
          "Principal Residence (Equity)": "Résidence principale (valeur nette)",
          "Other Real Estate (Equity)":
            "Autres biens immobiliers (valeur nette)",
          Vehicles: "Véhicules",
          "Collectibles/Art/Valuables": "Objets de collection / art / valeurs",
          "Total Other Assets": "Total des autres actifs",
          "Net Worth (Assets - Liabilities)": "Valeur nette (actifs - passifs)",
          "Vehicle(s) owned or being paid for? (After Mat Leave)":
            "Véhicule(s) possédé(s) ou en voie de paiement ? (Après congé de maternité)",
          "Does your recommendation consider the Subscriber(s)’ investment objectives and time horizon?":
            "Votre recommandation tient-elle compte des objectifs et de l’horizon du (des) souscripteur(s) ?",
          "Have you confirmed the reasonableness of the Subscriber(s)’ ability to meet the Plan Contribution Target?":
            "Avez-vous confirmé le caractère raisonnable de la capacité du (des) souscripteur(s) à atteindre l’objectif de cotisation au plan ?",
          "Have you confirmed the Subscriber(s)’ ability to meet the plan’s structured contribution requirements?":
            "Avez-vous confirmé la capacité du (des) souscripteur(s) à respecter les exigences de cotisations structurées du régime ?",
          "Have you reviewed and discussed all plan fees with the Subscriber(s)?":
            "Avez-vous examiné et discuté de tous les frais du régime avec le (les) souscripteur(s) ?",
          "Have you confirmed the Subscriber(s)’ ability to meet the plan’s structured contributions:":
            "Avez-vous confirmé la capacité du (des) souscripteur(s) à respecter les cotisations structurées du régime :",
          "Does your recommendation consider the Subscriber(s)' risk tolerance and risk capacity?":
            "Votre recommandation tient-elle compte de la tolérance au risque et de la capacité de risque du (des) souscripteur(s) ?",
          "Have you reviewed and discussed all disclosed plan risks with the Subscriber(s)?":
            "Avez-vous examiné et discuté de tous les risques du régime divulgués avec le (les) souscripteur(s) ?",
          "Considered Group": "Régime collectif envisagé",
          "Considered Achievers": "Régime des performants envisagé",
          "Considered SI": "Régime individuel envisagé",
          "For this/these Subscriber(s), is there a need or preference for flexibility vs. structure?":
            "Pour ce(s) souscripteur(s), existe-t-il un besoin ou une préférence pour la flexibilité au lieu de la structure ?",
          "If an alternative was not selected, briefly indicate why:":
            "Si aucne autre option n’a été retenue, veuillez indiquer brièvement pourquoi :",
          "Why this plan puts the Subscriber’s interest first:":
            "En quoi ce régime sert-il avant tout les intérêts du (des) souscripteur(s) :",
          "Risk profile conclusion": "Conclusion du profil de risque",
          "I believe the plan investment is suitable for the subscriber(s) because:":
            "Je crois que l’investissement dans le régime convient au(x) souscripteur(s) parce que :",
          "Other - Please note in the KYC Notes Section":
            "Autre – Veuillez l'indiquer dans la section Notes CVC",
          "The Subscriber(s) prefer a more structured, discipline-oriented savings approach.":
            "Le (les) souscripteur(s) préfère(nt) une approche d’épargne plus structurée et axée sur la discipline.",
          "A flexible plan may not support the Subscriber(s)’ long-term savings behaviour.":
            "Un régime flexible pourrait ne pas soutenir le comportement d’épargne à long terme du (des) souscripteur(s).",
          "The Subscriber(s) prefer predictable, scheduled contributions.":
            "Le (les) souscripteur(s) préfère(nt) des cotisations prévisibles et planifiées.",
          "The potential for group earnings aligns better with the Subscriber(s)’ long-term goal.":
            "Le potentiel de gains du groupe correspond davantage à l’objectif à long terme du (des) souscripteur(s).",
          "The Subscriber(s) do not require or desire the level of flexibility offered by individual plans.":
            "Le (les) souscripteur(s) n’a (n’ont) pas besoin ni ne souhaite(nt) le niveau de flexibilité offert par les régimes individuels.",
          "The Subscriber(s)’ financial situation supports structured contribution commitments.":
            "La situation financière du (des) souscripteur(s) permet de soutenir des engagements de cotisations structurées.",
          "The group structure aligns better with the Subscriber(s)’ education savings objectives.":
            "La structure du régime collectif correspond mieux aux objectifs d’épargne-études du (des) souscripteur(s).",
          "The Subscriber(s) prefer a plan that encourages consistent long-term contributions.":
            "Le (les) souscripteur(s) préfère(nt) un régime qui favorise des cotisations régulières à long terme.",
          "The selected plan better supports the Subscriber(s)’ long-term behaviour and goals.":
            "Le régime choisi soutient mieux le comportement et les objectifs à long terme du (des) souscripteur(s).",
          "The Subscriber(s) preferred the chosen plan after reviewing the trade-offs.":
            "Le (les) souscripteur(s) a (ont) privilégié le régime choisi après avoir examiné les compromis.",
          "Structured contributions support long-term savings discipline and align with the Subscriber(s)’ budget and cash-flow capacity, in accordance with CEFI’s Affordability Guidelines.":
            "Des cotisations structurées favorisent une discipline d’épargne à long terme et correspondent au budget et à la capacité de flux de trésorerie du (des) souscripteur(s), conformément aux lignes directrices d’abordabilité de FEEI.",
          "The time horizon aligns with the GOP structure, and the Subscriber(s) can maintain the scheduled contribution requirements":
            "L’horizon correspond à la structure du régime collectif, et les souscripteurs peuvent maintenir les exigences de cotisations programmées.",
          "Compared to Achievers and SIOP, the GOP structure better supports the Subscriber(s)’ savings behaviour and goals.":
            "Comparativement aux regimes des performants et individuel, la structure du régime collectif soutient mieux le comportement d’épargne et les objectifs des souscripteurs.",
          "The Subscriber(s) acknowledged key trade-offs (contribution obligations and plan risks) and prefers the structured approach of the GOP.":
            "Le (les) souscripteur(s) a (ont) reconnu les principaux compromis (obligations de cotisation et risques du régime) et privilégie(nt) l’approche structurée du régime collectif.",
          "KYC was reviewed and confirmed. The recommendation reflects current personal/financial circumstances, objectives, risk tolerance and capacity, and time horizon.":
            "Les renseignements « Connaissez votre client » (CVC) ont été examinés et confirmés. La recommandation tient compte de la situation personnelle et financière actuelle, des objectifs, de la tolérance et de la capacité de risque, ainsi que de l’horizon temporel.",
          "A reasonable range of alternatives was considered. The selected option best meets the Subscriber(s)’ needs.":
            "Un éventail raisonnable d’options a été considéré. L’option retenue répond le mieux aux besoins du (des) souscripteur(s).",
          "See notes below": "Voir les notes ci-dessous",
          "The beneficiary’s age and selected plan align more closely with the Subscriber(s)’ time horizon.":
            "L’âge du bénéficiaire et le régime choisi correspondent davantage à l’horizon du (des) souscripteur(s).",
          "The Subscriber(s) prefer contribution flexibility rather than structured contributions.":
            "Le (les) souscripteur(s) préfère(nt) la flexibilité des cotisations plutôt que des cotisations structurées.",
          "The Subscriber(s)’ income/cash flow is variable and cannot support scheduled contributions.":
            "Le revenu ou les flux de trésorerie du (des) souscripteur(s) sont variables et ne permettent pas de soutenir des cotisations programmées.",
          "The group plan structure is too restrictive for the Subscriber(s)’ circumstances.":
            "La structure du régime collectif est trop restrictive pour la situation du (des) souscripteur(s).",
          "Contribution obligations may present an affordability risk for the Subscriber(s).":
            "Les obligations de cotisation peuvent présenter un risque d’abordabilité pour le (les) souscripteur(s).",
          "The Subscriber(s) prefer full control over contribution timing and amounts.":
            "Le (les) souscripteur(s) préfèrent avoir un contrôle total sur le moment et le montant des cotisations.",
          "The Subscriber(s)’ risk capacity does not support mandatory contribution scheduling":
            "La capacité de risque du (des) souscripteur(s) ne permet pas de soutenir des cotisations obligatoires programmées.",
          "An individual plan option better matches the Subscriber(s)’ savings behaviour.":
            "Un régime individuel correspond mieux au comportement d’épargne du (des) souscripteur(s).",
          "The contribution requirements/structure did not match the Subscriber(s)’ cash flow.":
            "Les exigences ou la structure des cotisations ne correspondaient pas aux flux de trésorerie du (des) souscripteur(s).",
          "Goal-based Plan Contribution Targets provide structure with greater flexibility than a Group Option Plan, better matching the Subscriber(s)’ cash-flow variability.":
            "Les objectifs de cotisation au plan axés sur des cibles offrent une structure avec une plus grande flexibilité qu’un régime collectif, s'adaptant ainsi mieux à la variabilité des flux de trésorerie du (des) souscripteur(s).",
          "The Subscriber(s)’ risk tolerance and risk capacity align with Achievers’ features and the long-time horizon for education savings.":
            "La tolérance et la capacité de risque du (des) souscripteur(s) correspondent aux caractéristiques du régime Achievers et à l’horizon à long terme de l’épargne-études.",
          "Compared to GOP and SIOP, Achievers balances discipline and adaptability, meeting the Subscriber(s)’ needs and objectives.":
            "Comparativement aux régimes collectif et individuel, le régime des performants équilibre discipline et adaptabilité, répondant ainsi aux besoins et aux objectifs du (des) souscripteur(s).",
          "The Subscriber(s) understands plan risks, plan contribution targets, and fees, and this option puts the client’s interest first, relative to the alternatives.":
            "Le (les) souscripteur(s) comprend (comprennent) les risques, les objectifs de cotisation et les frais du régime, et cette option privilégie les intérêts du client par rapport aux autres solutions.",
          "Maximum contribution flexibility best suits the Subscriber(s)’ variable income and liquidity needs without contractual contribution obligations.":
            "La flexibilité maximale des cotisations convient le mieux au revenu variable et aux besoins de liquidité du (des) souscripteur(s), sans obligations contractuelles de cotisation.",
          "The Subscriber(s) wishes to open this plan to collect the Canada Learning Bond (CLB) without making contributions at this time.":
            "Le (les) souscripteur(s) souhaite(nt) ouvrir ce régime afin de recevoir le Bon d’études canadien (BEC) sans effectuer de cotisations pour le moment.",
          "The time horizon and risk profile are compatible with SIOP features and the Subscriber(s)’ savings preferences.":
            "L’horizon et le profil de risque sont compatibles avec les caractéristiques du régime individuel et les préférences d’épargne du (des) souscripteur(s).",
          "Compared to GOP and Achievers, SIOP provides the adaptability the Subscriber(s) needs to stay on track toward objectives.":
            "Comparativement aux régimes collectif et des performants, le régime individuel offre l’adaptabilité dont les souscripteurs ont besoin pour rester sur la bonne voie vers leurs objectifs.",
          "The Subscriber(s) understands the plan’s features, risks, and fees, and this option puts the client’s interest first given their circumstances.":
            "Le (les) souscripteur(s) comprend (comprennent) les caractéristiques, risques et frais du régime, et cette option sert au mieux l’intérêt du client compte tenu de sa (leur) situation.",
          "Suitability Rationale": "Justification de la pertinence",
          "Are you a Politically Exposed Person (PEP) or Head of an International Organization (HIO)?":
            "Êtes-vous une personne politiquement exposée ou un dirigeant d’une organisation internationale ?",
          "Have you confirmed the Subscriber's willingness to make ongoing, structured contributions?":
            "Avez-vous confirmé la volonté du souscripteur d’effectuer des cotisations continues et structurées ?",
          "Do the Subscriber(s) have a need or preference for contribution flexibility?":
            "Le (les) souscripteur(s) ont-ils un besoin ou une préférence en matière de flexibilité des cotisations ?",
          "For this/these Subscriber(s), is there a need or preference for flexibility vs. structure?":
            "Pour ce(s) souscripteur(s), existe-t-il un besoin ou une préférence pour la flexibilité au lieu de la structure ?",
          "If you were unable to keep the contributions in the plan until maturity, do you have the ability to absorb any loss that may occur?":
            "Si vous n’êtes pas en mesure de conserver les cotisations dans le régime jusqu'à l'échéance, avez-vous la capacité de supporter toute perte qui pourrait survenir ?",
          YES: "OUI",
          NO: "NON",
        },
      },
    },
  });

export default i18n;
